var _path, _rect, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 556,
    height: 169,
    viewBox: "0 0 556 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 0,
    width: 558,
    height: 169
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M534.844 2.5H19.1562C9.12879 2.5 1 6.92672 1 12.3873V156.613C1 162.073 9.12879 166.5 19.1562 166.5H534.844C544.871 166.5 553 162.073 553 156.613V12.3873C553 6.92672 544.871 2.5 534.844 2.5Z",
    fill: "#DDC4A6",
    stroke: "#56111D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_805)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19_805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -38,
    width: 578,
    height: 280
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -37.5156,
    width: 578,
    height: 278.906,
    rx: 24,
    fill: "#353434"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19_805)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -59.2969,
    width: 623.688,
    height: 354.344,
    rx: 24,
    fill: "#1E6357"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9619 21.3383L55.6015 12.5H71.3429L81.9448 19.9179L92.2933 30.037L94.6597 29.4721L99.8037 42.5087L106.747 47.5764L100.373 72.6731L101.556 80.3979L99.8037 84.4753L100.373 99.7993L93.9065 114.031L89.3994 128.232L85.0758 136.301L85.9824 140.232L107.877 155.658C107.877 155.658 87.656 157.599 87.5723 157.587C87.4887 157.576 126.382 167.823 126.382 167.823L67.4819 172.516L45.9619 21.3383Z",
    fill: "#174F45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1886 157.478C88.9971 159.428 90.8078 169.285 92.6163 171.235H83.3672C84.641 169.285 85.9148 159.428 87.1863 157.478H87.1886Z",
    fill: "#C0D5D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9409 145.476C43.4444 147.631 45.9478 149.788 48.4513 151.943C47.475 148.038 46.4987 144.13 45.5225 140.225C43.9953 141.975 42.4681 143.726 40.9409 145.478V145.476Z",
    fill: "#FAFDFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5723 148.363C37.0687 153.41 44.5651 166.358 52.0616 171.405L43.7655 151.092C39.0352 150.183 34.3026 149.272 29.5723 148.363Z",
    fill: "#647C90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6465 139.959C45.6576 142.145 46.6688 144.33 47.6799 146.515L47.8636 151.032C46.792 147.34 45.7181 143.649 44.6465 139.959Z",
    fill: "#DAD5CF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7314 160.223C57.8774 158.115 59.0234 156.006 60.1717 153.896C59.3046 156.608 58.4353 167.225 57.5683 169.938C57.2893 169.333 57.0104 160.825 56.7338 160.221L56.7314 160.223Z",
    fill: "#D9B19B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9888 58.6763C35.8641 60.4662 38.7395 62.2562 41.6149 64.0485C39.3183 71.4315 37.0241 78.8122 34.7275 86.1953L32.9888 58.6763Z",
    fill: "#454342"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9323 50.0405C51.889 52.1048 49.8458 54.1691 47.8003 56.2333C57.24 54.3876 66.6797 52.5442 76.1217 50.6984C68.7252 50.4799 61.3287 50.259 53.9323 50.0405Z",
    fill: "#896762"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5698 56.0657H86.2777C81.4823 54.1688 76.6869 52.2719 71.8892 50.375C72.4494 52.2719 73.0096 54.1688 73.5698 56.0657Z",
    fill: "#54443D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3206 81.6252L40.9409 63.2188C41.2733 69.3535 41.608 75.4905 41.9404 81.6252H49.3206Z",
    fill: "#AE7861"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2973 33.933C82.3006 37.3526 75.3039 40.7698 68.3096 44.1893C71.0757 38.122 73.8441 32.057 76.6103 25.9897L89.2973 33.933Z",
    fill: "#37383E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4429 53.3044C92.9394 58.4046 95.4335 63.5049 97.93 68.6051C97.6185 61.9613 97.307 55.3175 96.9979 48.6714C94.8129 50.2149 92.6279 51.7585 90.4452 53.3044H90.4429Z",
    fill: "#5A2A30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2773 56.0657L93.2973 52.96C94.2991 56.6561 95.3009 60.3523 96.3028 64.0485C92.9602 61.3868 89.6176 58.7274 86.2773 56.0657Z",
    fill: "#3A2A2F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4287 73.2147L21.7593 52.6533L34.7298 86.1931L22.4287 73.2147Z",
    fill: "#312F2F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9862 54.5133L72.0729 50.7334C72.7703 52.893 73.47 55.0526 74.1673 57.2121C67.4403 56.3125 60.7132 55.4129 53.9839 54.5133H53.9862Z",
    fill: "#997467"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5698 56.0654L73.1328 60.1777L86.2777 56.0654H73.5698Z",
    fill: "#7B5B4B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3999 115.835L89.6341 110.288C88.0605 109.742 86.4845 109.193 84.9108 108.647C84.4064 111.044 83.9043 113.44 83.3999 115.835Z",
    fill: "#996E61"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1333 112.387L79.0342 115.493C79.6897 113.861 80.3476 112.232 81.0031 110.6C79.3806 111.195 77.7558 111.792 76.1333 112.387Z",
    fill: "#D7A89B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3999 115.834C83.9043 113.763 84.4064 111.692 84.9108 109.623C82.9582 110.274 81.0057 110.925 79.0508 111.576C80.5013 112.996 81.9494 114.414 83.3999 115.834Z",
    fill: "#B38271"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9131 111.576C72.6495 111.852 74.3859 112.127 76.1222 112.403L75.6015 115.402C74.0395 114.126 72.4775 112.852 70.9131 111.576Z",
    fill: "#D49D8A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1005 122.971C63.9676 123.513 64.8369 124.057 65.704 124.598C61.3084 126.932 56.9151 129.264 52.5195 131.598C56.0458 128.722 59.572 125.847 63.0982 122.971H63.1005Z",
    fill: "#D2AA9E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9795 128.829C82.2538 125.112 82.5257 121.393 82.8 117.676L84.4481 118.413C83.6252 121.886 82.8024 125.359 81.9795 128.829Z",
    fill: "#8D655F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7017 127.962L44.0582 125.737C50.1878 129.808 56.3198 133.876 62.4494 137.946C55.1994 134.62 47.9517 131.291 40.7017 127.964V127.962Z",
    fill: "#A17E75"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5215 131.598L65.7036 143.656L72.3981 136.889L52.5215 131.598Z",
    fill: "#624843"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.167 80.9742C76.2288 78.803 78.2906 76.6341 80.3524 74.4629C81.0033 75.4392 81.6541 76.4156 82.305 77.3919C79.5923 78.5845 76.8797 79.7793 74.167 80.9719V80.9742Z",
    fill: "#C28C77"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1435 83.2544C69.853 92.9132 64.5625 102.57 59.272 112.229H67.3425C69.9436 102.57 72.5424 92.9132 75.1435 83.2544Z",
    fill: "#D6AA99"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5449 81.6253C74.4807 80.8652 77.4165 80.105 80.3547 79.3472C77.8164 81.5184 75.278 83.6873 72.7374 85.8585L71.5449 81.6253Z",
    fill: "#B6816D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0015 68.9302C95.987 71.55 96.9726 74.1676 97.9582 76.7874C97.4073 78.51 96.8541 80.2302 96.3032 81.9528C95.8685 77.6127 95.4361 73.2726 95.0015 68.9302Z",
    fill: "#2A1110"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0254 58.8389C95.3364 61.7888 96.6474 64.7411 97.9584 67.6911C97.189 70.8177 96.4219 73.942 95.6525 77.0686C95.1109 70.9921 94.567 64.9155 94.0254 58.8389Z",
    fill: "#543030"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.027 123.622L70.75 126.388C70.0457 125.574 69.3391 124.761 68.6348 123.947C72.433 123.838 76.2312 123.731 80.027 123.622Z",
    fill: "#956861"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9819 88.5154L63.2696 90.8796C63.2139 89.422 63.1557 87.9668 63.0999 86.5093C61.0614 87.1788 59.0205 87.8459 56.9819 88.5154Z",
    fill: "#CA9789"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6606 89.4383C56.8917 89.8613 60.1204 90.2821 63.3514 90.7052C61.3151 89.9567 59.2789 89.2104 57.2427 88.4619C56.0502 88.7874 54.8554 89.1128 53.663 89.4383H53.6606Z",
    fill: "#D4A597"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6606 85.2075C53.7699 86.0746 53.8768 86.944 53.9861 87.8111C55.6132 87.9204 57.2403 88.0273 58.8698 88.1366C57.1334 87.1602 55.397 86.1839 53.6606 85.2075Z",
    fill: "#AD847E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6182 84.5565L49.8204 87.3275L56.3545 83.271L49.6182 84.5565Z",
    fill: "#C08D7E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3208 81.625C49.3557 83.1453 49.3929 84.6633 49.4277 86.1836C52.4658 84.6633 55.5039 83.1453 58.542 81.625H49.3208Z",
    fill: "#BA9181"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2855 70.8829C72.6258 72.1544 75.9661 73.426 79.304 74.6976L74.9898 58.3252C73.0884 62.5119 71.1846 66.6985 69.2832 70.8852L69.2855 70.8829Z",
    fill: "#DAA88F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0483 85.2075C93.1646 86.1839 93.2808 87.1602 93.3947 88.1366H95.3263C94.5662 87.1602 93.8061 86.1839 93.0483 85.2075Z",
    fill: "#9F766F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3266 94.3223H93.374C93.4833 95.9495 93.5902 97.5767 93.6994 99.2063C94.2411 97.5791 94.785 95.9518 95.3266 94.3223Z",
    fill: "#9B6D5C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2701 89.073L92.8349 87.4876C92.4723 87.3783 92.1097 87.2714 91.7471 87.1621C91.9214 87.7991 92.0957 88.436 92.2701 89.073Z",
    fill: "#7B5A4F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4902 89.1128C89.0458 88.548 89.6013 87.9831 90.1569 87.4182C89.7106 87.3322 89.2643 87.2462 88.8157 87.1602C88.7064 87.8111 88.5995 88.4619 88.4902 89.1128Z",
    fill: "#946A5B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8394 89.1129C88.6948 89.4383 89.5502 89.7638 90.4033 90.0892C90.6334 88.8967 90.8635 87.7018 91.0936 86.5093C90.0081 87.3764 88.9226 88.2458 87.8394 89.1129Z",
    fill: "#9D6A5D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3266 98.767L93.374 98.23C93.4833 99.4225 93.5902 100.617 93.6994 101.81L95.3266 98.767Z",
    fill: "#8E5E53"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2124 90.0889C86.6471 89.438 87.0794 88.7871 87.5141 88.1362C88.0348 89.438 88.5578 90.7375 89.0785 92.0393L86.2124 90.0889Z",
    fill: "#C28A76"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8157 91.0679C88.7064 93.6715 88.5995 96.2774 88.4902 98.881L93.374 94.3224C91.8538 93.2368 90.3359 92.1512 88.8157 91.0679Z",
    fill: "#BF8571"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.374 94.3223L88.4902 98.8809H94.0248C93.8086 97.3606 93.5901 95.8426 93.374 94.3223Z",
    fill: "#AD7866"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2972 110.139L85.2178 109.263L87.3493 107.429L89.2972 110.139Z",
    fill: "#97645B"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6995 101.81L91.0938 103.437L93.6995 103.393V101.81Z",
    fill: "#7C5548"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2728 101.18L91.2402 101.81L93.6995 98.8135L91.2728 101.18Z",
    fill: "#9D6E60"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8761 94.3967L85.5614 89.0059L85.229 93.5087L88.8761 94.3967Z",
    fill: "#D19983"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2141 87.437H67.4006C66.6195 87.9949 65.8362 88.5552 65.0552 89.1131C66.1082 88.5552 67.1635 87.9949 68.2165 87.437H68.2141Z",
    fill: "#C89C8E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.214 87.437C68.2442 87.9949 68.2768 88.5552 68.307 89.1131H65.0527C66.1057 88.5552 67.161 87.9949 68.214 87.437Z",
    fill: "#CCA08D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1445 90.2586L69.695 94.8242C69.7763 93.0295 69.8553 91.2349 69.9367 89.438C69.3393 89.7123 68.7419 89.9843 68.1445 90.2586Z",
    fill: "#F6C8B7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6108 89.7637C70.2082 91.7931 70.8056 93.8225 71.403 95.8519L71.1752 89.3174C70.6545 89.4662 70.1338 89.6149 69.6132 89.7637H69.6108Z",
    fill: "#F0BA9F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.167 86.5092C73.2442 86.2442 72.3237 85.9769 71.4009 85.7119L71.4613 84.9819C72.3632 85.491 73.2651 86.0001 74.167 86.5092Z",
    fill: "#C89480"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8656 86.5091C72.4239 84.8818 71.9846 83.2546 71.543 81.625H72.9237C72.9051 83.2522 72.8842 84.8795 72.8656 86.5091Z",
    fill: "#A5735F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4712 83.5801C75.1156 83.5987 74.7599 83.6149 74.4043 83.6312V85.6955C74.7599 84.9911 75.1156 84.2844 75.4712 83.5801Z",
    fill: "#BA8572"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3534 86.7259L83.9322 85.8564H86.5356C85.4733 86.147 84.4134 86.4353 83.3511 86.7259H83.3534Z",
    fill: "#DFD9D0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6308 90.4144C82.5982 89.4148 82.5657 88.4176 82.5332 87.418L81.7266 89.0336C82.0287 89.4939 82.3286 89.9541 82.6308 90.4144Z",
    fill: "#AF8A89"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6543 88.1368C81.9611 87.8973 82.268 87.6579 82.5748 87.4184C82.268 87.2232 81.9611 87.0279 81.6543 86.835V88.1368Z",
    fill: "#946D65"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1277 87.0368C82.9626 87.1855 82.7976 87.3366 82.6326 87.4854C82.5233 86.8345 82.4164 86.1836 82.3071 85.5327C82.5814 86.0348 82.8557 86.5346 83.1277 87.0368Z",
    fill: "#B0816B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8871 86.8349C85.8592 86.6768 85.829 86.5187 85.8011 86.3607L84.7783 86.3374C85.1479 86.5025 85.5175 86.6675 85.8894 86.8326L85.8871 86.8349Z",
    fill: "#D7C3BA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2812 86.8344H86.8609C86.1566 86.6716 85.45 86.5089 84.7457 86.3462C84.2575 86.5089 83.7694 86.6716 83.2812 86.8344Z",
    fill: "#D9C0B6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7987 87.4859L86.6378 86.9187C85.7359 86.8908 84.834 86.8629 83.9321 86.835C84.5551 87.0512 85.1757 87.2697 85.7987 87.4859Z",
    fill: "#C19C92"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5855 87.1599C84.3228 87.0042 84.0625 86.8461 83.7998 86.6903L85.8012 86.6206C85.3967 86.7996 84.9899 86.9786 84.5855 87.1599Z",
    fill: "#C6ADA3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1649 87.1602C87.2979 87.5949 86.4286 88.0272 85.5615 88.4619L85.8009 87.4856C86.5889 87.3763 87.3769 87.2694 88.1673 87.1602H88.1649Z",
    fill: "#B88E81"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8632 89.1128C86.4425 89.0989 86.0194 89.0849 85.5987 89.071L85.5615 88.4619C85.9962 88.6781 86.4286 88.8966 86.8632 89.1128Z",
    fill: "#BA8D77"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3052 99.8574C82.8468 99.6413 83.3907 99.4227 83.9323 99.2065C84.0416 100.727 84.1485 102.245 84.2577 103.765C83.6069 102.463 82.956 101.162 82.3052 99.8598V99.8574Z",
    fill: "#BE876D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4155 98.7905L80.408 103.479C80.064 103.575 79.72 103.668 79.376 103.763C79.3899 102.105 79.4015 100.448 79.4155 98.7905Z",
    fill: "#E2B89A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0507 109.623C77.9651 109.189 76.8796 108.756 75.7964 108.322C78.2929 108.212 80.787 108.105 83.2835 107.996C81.8726 108.538 80.4616 109.082 79.0507 109.623Z",
    fill: "#745347"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9035 100.801L85.287 93.1064C84.7268 94.2711 84.1666 95.4357 83.6064 96.6004C84.0388 97.9998 84.4712 99.4016 84.9035 100.801Z",
    fill: "#946855"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2358 96.9261C85.0196 98.0118 84.8011 99.0974 84.585 100.181C84.9104 101.482 85.2358 102.784 85.5612 104.086C85.452 101.699 85.3451 99.3112 85.2358 96.9238V96.9261Z",
    fill: "#996555"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M86.538 109.623L87.2981 104.778L87.391 109.623H86.5356H86.538Z",
    fill: "#75483F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3447 111.957L71.4614 108.37L67.4935 106.831L67.3447 111.957Z",
    fill: "#E7C3AC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9561 101.038L76.1221 98.8809V103.437L77.9561 101.038Z",
    fill: "#F2CDBC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8871 76.0574L81.0034 75.8691L82.4213 81.6249L85.8871 76.0574Z",
    fill: "#B48173"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7287 76.2646L82.3745 81.6253H85.043L85.7287 76.2646Z",
    fill: "#A87E78"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0034 75.8691V81.2995L82.4213 81.6249L81.0034 75.8691Z",
    fill: "#CE9A89"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7578 85.7905L88.8159 87.4852L90.6174 85.7905H88.7578Z",
    fill: "#AB8E7C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M92.04 84.9819V85.7909L93.1093 85.8049L92.04 84.9819Z",
    fill: "#6E4A46"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8159 82.9292L91.0939 83.4592L90.3594 85.5328L88.8159 82.9292Z",
    fill: "#849392"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5088 85.7911L89.4479 83.8198L90.7682 85.9631L88.5088 85.7911Z",
    fill: "#7A8483"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9346 84.3939C84.5552 84.2312 85.1735 84.0685 85.7941 83.9058C86.0429 84.5567 86.2893 85.2076 86.538 85.8585C85.671 85.3703 84.8016 84.8821 83.9346 84.3939Z",
    fill: "#9B9A9B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7133 82.2759H56.5078V83.4289L59.7133 82.2759Z",
    fill: "#423735"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9814 81.1694L63.1301 82.3992L58.272 82.7665L62.9814 81.1694Z",
    fill: "#503C3B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1305 82.3992L65.7037 82.1459L62.6958 78.7798L63.1305 82.3992Z",
    fill: "#5E4C3A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4409 87.0833L65.1666 85.563L61.7984 87.7667L60.4409 87.0833Z",
    fill: "#BABDB0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6449 83.2549L71.5449 84.2312L63.1001 79.3472L66.6449 83.2549Z",
    fill: "#7F5F54"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0366 84.3865L85.1012 83.2544H85.7288L85.8892 84.3865H84.0366Z",
    fill: "#595150"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5615 83.343L85.9706 85.5328L87.8395 82.9292L85.5615 83.343Z",
    fill: "#4A4245"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9343 84.2314L87.514 85.8261C86.2123 85.947 84.9106 86.0656 83.6089 86.1865C83.7181 85.5356 83.8251 84.8847 83.9343 84.2338V84.2314Z",
    fill: "#D3E0E0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2974 85.7001V80.7603L88.3765 81.625L93.2974 85.7001Z",
    fill: "#3D312D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0034 86.1839V81.2998L87.1888 81.6253C85.127 83.1456 83.0652 84.6636 81.0034 86.1839Z",
    fill: "#7F5C57"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1182 86.1841V84.2314L66.3543 84.9242L64.1182 86.1841Z",
    fill: "#CFC7BE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M63.751 84.3263L66.6798 85.2073L64.3879 83.5801L63.751 84.3263Z",
    fill: "#A5968D"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1179 84.4751V85.8164L62.1235 86.5092L64.1179 84.4751Z",
    fill: "#BAB2AE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5044 87.2555L60.4412 87.4369L63.7512 86.4814L59.5044 87.2555Z",
    fill: "#C7CDC5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8672 87.4854L59.9155 86.6671L63.7509 86.1836L58.8672 87.4854Z",
    fill: "#B9C2B6"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7749 83.1734L66.0129 81.9507L67.4006 83.5802L62.7749 83.1734Z",
    fill: "#53413F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7948 85.5536L59.0811 87.2018L61.1476 86.3905L54.6367 85.5327",
    fill: "#DCE6E4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5068 83.2544L64.7272 83.8797L63.8671 84.7189L63.5068 83.2544Z",
    fill: "#91877D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4409 83.6938L61.9425 83.1963L62.9816 85.1676L60.4409 83.6938Z",
    fill: "#4C4741"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7746 85.4282L63.8322 84.5774L62.6909 84.4751L62.7746 85.4282Z",
    fill: "#443E36"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5071 83.2544L63.8325 84.5771L62.7749 84.7073L63.5071 83.2544Z",
    fill: "#574C3F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7477 83.4287L64.4019 83.2544L67.4795 85.9696L65.7477 83.4287Z",
    fill: "#57514A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2866 84.8816L63.2071 84.5562L63.507 83.2544L62.2866 84.8816Z",
    fill: "#776F67"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7988 82.9292H63.7514L62.287 84.8819L61.7988 82.9292Z",
    fill: "#716659"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54.311 85.8584L58.5416 83.9057L57.8907 82.6016L54.311 85.8584Z",
    fill: "#493D30"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M58.542 83.9054L62.7749 83.2545L62.124 82.2759L58.542 83.9054Z",
    fill: "#28211B"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8909 82.6016L52.0332 84.882L54.3112 85.8584L57.8909 82.6016Z",
    fill: "#A58C72"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M58.542 83.9055L60.0087 83.5801L59.5717 85.37L58.542 83.9055Z",
    fill: "#28211B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0088 83.5802L61.2105 83.4941L60.6596 84.6146L60.0088 83.5802Z",
    fill: "#F1F8FA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1235 82.2761L62.7744 83.2548L66.0124 81.9507L62.1235 82.2761Z",
    fill: "#433F39"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8911 82.6013L58.542 83.9054L62.124 82.2759L57.8911 82.6013Z",
    fill: "#3A3E38"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5713 85.37L60.0083 83.5801L60.6591 84.6145L59.5713 85.37Z",
    fill: "#3E4143"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3426 84.6146H60.6597L61.2106 83.4941L62.3426 84.6146Z",
    fill: "#969B9E"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9377 85.2075L60.6597 84.6147H62.3426L62.9377 85.2075Z",
    fill: "#4A463F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5713 85.3703L60.171 86.1839L60.6591 84.6147L59.5713 85.3703Z",
    fill: "#555C5B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1714 86.1839L61.1477 86.5093L60.6595 84.6147L60.1714 86.1839Z",
    fill: "#515448"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M54.311 85.8585L58.5044 83.9058L59.0809 84.731L54.311 85.8585Z",
    fill: "#8F9391"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0181 84.6494L59.5736 85.4026L54.311 85.8582L59.0181 84.6494Z",
    fill: "#BEC6CA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5717 85.3701L60.1714 86.1837L54.8438 85.7211L59.5717 85.3701Z",
    fill: "#D1DADF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1712 86.1837L61.1474 86.5091L55.2456 85.7769L60.1712 86.1837Z",
    fill: "#CFE5D6"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3872 85.793L58.5415 88.1362L59.2737 87.2017L55.3872 85.793Z",
    fill: "#D0C9BC"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0766 82.9292L63.8325 83.2546L67.3495 85.8164L64.0766 82.9292Z",
    fill: "#3F3231"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M58.542 88.1362L60.641 87.5178L59.2742 87.2017L58.542 88.1362Z",
    fill: "#D3CDCE"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M58.542 88.1363L61.7986 87.7667L60.8618 87.2832L58.542 88.1363Z",
    fill: "#F0ECEA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7507 86.4814L66.203 85.0518L63.5996 86.0839L63.7507 86.4814Z",
    fill: "#D9CDC4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1592 84.9517L67.4795 85.9698L62.2866 87.3367L66.1592 84.9517Z",
    fill: "#DCBFB3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1714 87.9507H63.063L62.9817 87.1533L60.1714 87.9507Z",
    fill: "#C8BFB6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9996 86.623L63.0633 87.9504L62.9819 87.1531L64.9996 86.623Z",
    fill: "#DDCBC5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9993 86.6229L66.2708 86.3091L63.063 87.9503L64.9993 86.6229Z",
    fill: "#C39C8E"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2705 86.3091L67.4792 85.9697L67.4002 87.153L66.2705 86.3091Z",
    fill: "#FEE8E1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M63.063 87.9506L67.4005 87.1532L65.499 86.7046L63.063 87.9506Z",
    fill: "#AF887D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M65.499 86.7043L66.2708 86.3091L67.4004 87.1529L65.499 86.7043Z",
    fill: "#E8CFC8"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1235 82.2759L64.0761 83.0593L62.6907 83.2545L62.1235 82.2759Z",
    fill: "#2B241D"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3297 83.615L62.4492 83.1686L64.0229 82.9292L64.3297 83.615Z",
    fill: "#332922"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1241 86.3094L62.9377 85.2075L60.6597 84.6147L62.1241 86.3094Z",
    fill: "#434441"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1478 86.5093L62.1241 86.3094L60.6597 84.6147L61.1478 86.5093Z",
    fill: "#484D4B"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1235 86.3094L63.0998 85.4005L62.9371 85.2075L62.1235 86.3094Z",
    fill: "#424543"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1002 85.4003L63.6 84.6146L61.2104 83.4941L63.1002 85.4003Z",
    fill: "#4A463F"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0284 86.3276L61.2102 86.6229L61.1475 86.509L62.0284 86.3276Z",
    fill: "#4A463F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5999 84.7077V84.6147L63.1001 85.4005L63.5999 84.7077Z",
    fill: "#38352F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1475 86.509C61.3636 86.6183 61.5821 86.7252 61.7983 86.8344C61.9076 86.6601 62.0145 86.4834 62.1237 86.3091L61.1475 86.509Z",
    fill: "#3C3F3E"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7988 86.8344L62.1243 86.509V86.3091C62.015 86.4834 61.9081 86.6601 61.7988 86.8344Z",
    fill: "#38352F"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1235 86.5093C62.449 86.2931 62.7744 86.0746 63.0998 85.8584C62.7744 86.0095 62.449 86.1583 62.1235 86.3094V86.5093Z",
    fill: "#38352F"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7985 86.5093C61.4731 86.6185 61.1477 86.7255 60.8223 86.8347L61.1477 86.5093H61.7985Z",
    fill: "#484D4B"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0998 85.8584L63.2672 85.168L62.1235 86.3094C62.449 86.1583 62.7744 86.0095 63.0998 85.8584Z",
    fill: "#38352F"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8222 86.8345L60.1714 86.1836L61.1477 86.509L60.8222 86.8345Z",
    fill: "#42443B"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8224 86.8345C60.5249 86.7903 60.2297 86.7462 59.9321 86.7043L60.1715 86.1836L60.8224 86.8345Z",
    fill: "#515448"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1001 85.8584C63.2675 85.4446 63.4348 85.0309 63.5999 84.6147L63.2675 85.168L63.1001 85.8584Z",
    fill: "#38352F"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9316 86.7045L59.5713 85.3701L60.171 86.1837L59.9316 86.7045Z",
    fill: "#484D4C"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9319 86.7043L59.0742 84.647L59.5717 85.3699L59.9319 86.7043Z",
    fill: "#2F3233"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0742 84.5844L58.9277 83.7289L59.4461 83.4941L59.0742 84.5844Z",
    fill: "#38352F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5717 85.3701L59.0742 84.6472L59.4461 83.4941L59.5717 85.3701Z",
    fill: "#423E38"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6531 86.0376L59.1348 85.2542L59.2254 85.0078L59.6531 86.0376Z",
    fill: "#38352F"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8301 84.373L59.1346 85.2541L59.3229 84.8821L58.8301 84.373Z",
    fill: "#38352F"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1001 85.8585L63.8323 84.8821L63.5999 84.373L63.1001 85.8585Z",
    fill: "#38352F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6597 86.8344H61.7987L61.3245 86.5508L60.6597 86.8344Z",
    fill: "#363A38"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1235 86.5091L64.1179 85.8164L63.7507 86.4812L62.1235 86.5091Z",
    fill: "#CCC5BE"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M81.654 87.1602C81.5448 86.6186 81.4379 86.0746 81.3286 85.533C81.9283 85.4237 82.528 85.3168 83.1278 85.2075L81.6564 87.1602H81.654Z",
    fill: "#1E1614"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1278 85.2076L81.3286 85.5331L82.2282 83.5664L83.1278 85.2076Z",
    fill: "#2D2625"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2285 83.5663L84.5855 81.9507L85.1016 83.5663H82.2285Z",
    fill: "#392E30"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M85.101 83.5663L87.5138 83.2548L84.585 81.9507L85.101 83.5663Z",
    fill: "#493C3F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M84.585 81.9505L87.1884 81.625L87.5138 83.2546L84.585 81.9505Z",
    fill: "#2A2A2C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5139 83.2546H89.7919L87.1885 81.625L87.5139 83.2546Z",
    fill: "#423431"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1885 81.625L89.7919 81.8086V83.2546L87.1885 81.625Z",
    fill: "#372C2C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6764 85.5325L89.2389 83.2544H87.5142L88.6764 85.5325Z",
    fill: "#2B2120"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1279 85.2073L84.0368 85.7908V84.3867L83.1279 85.2073Z",
    fill: "#AB9C8B"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M89.792 83.2545L94.0249 86.509L89.792 81.8086V83.2545Z",
    fill: "#53413B"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2598 81.4835L96.3029 79.998L89.1249 81.9507L84.2598 81.4835Z",
    fill: "#342828"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2851 83.6313L90.1572 86.5092L92.154 85.0703L90.2851 83.6313Z",
    fill: "#A4746C"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0368 85.791L83.1279 87.037V85.2075",
    fill: "#C5AFA9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5142 83.2544L86.0498 85.2071L87.1888 85.7906L86.0498 85.5325V85.2071L87.1888 85.7906L87.5142 83.2544L88.6765 85.5325L87.1888 85.7906",
    fill: "#322E30"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0435 81.4182L85.7292 76.0576L93.2977 80.7604L85.0435 81.4182Z",
    fill: "#4B3E3B"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7285 76.0574L88.6759 75.8691L88.3761 77.7033L85.7285 76.0574Z",
    fill: "#755554"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6763 75.8691L88.3765 77.8753L91.4215 79.6722L88.6763 75.8691Z",
    fill: "#3F3634"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M88.165 75.8691H95.9776L91.1659 79.6722L88.165 75.8691Z",
    fill: "#332723"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8216 75.8691L96.9978 80.7602L91.4214 79.3468L95.8216 75.8691Z",
    fill: "#493E33"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0997 80.7603H96.9979L89.792 78.8076L93.0997 80.7603Z",
    fill: "#634A3F"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9979 80.7603L93.2974 85.7001V80.7603H96.9979Z",
    fill: "#6E574E"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9979 80.7603L96.9538 88.1363L93.2974 85.7001L96.9979 80.7603Z",
    fill: "#7F4F43"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7372 77.7036L72.9232 81.6253H65.0874L72.7372 77.7036Z",
    fill: "#6B544C"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7376 77.7036L58.542 77.4224L65.0877 81.6253L72.7376 77.7036Z",
    fill: "#685251"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M58.542 77.4224L49.3208 81.6253H65.0877L58.542 77.4224Z",
    fill: "#75655C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0508 109.623L83.6649 107.326L85.7244 109.623H79.0508Z",
    fill: "#3F332F"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9771 75.8692L95.0008 66.3242L85.7285 76.0575L95.9771 75.8692Z",
    fill: "#B07563"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6514 69.8413L84.585 69.9064L85.7286 76.0574L91.6514 69.8413Z",
    fill: "#BC8A7A"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7749 119.389C67.0496 118.059 71.3243 116.732 75.6014 115.402C76.5335 116.406 77.4679 117.408 78.4 118.412C73.1909 118.738 67.9841 119.063 62.7749 119.389Z",
    fill: "#AA7675"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M74.167 119.063C75.7941 117.871 77.4213 116.676 79.0507 115.483L84.5853 117.515C81.1125 118.031 77.6398 118.547 74.1693 119.063H74.167Z",
    fill: "#664746"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M65.499 118.413L72.7374 124.036L77.4236 118.413H65.499Z",
    fill: "#CD8B91"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6823 118.894L73.5163 120.691L69.0068 119.396L71.6823 118.894Z",
    fill: "#F8C6CB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7373 124.036L80.0269 123.622L77.4234 118.413L72.7373 124.036Z",
    fill: "#C4847F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8003 117.676L80.0272 123.622L77.4238 118.413L82.8003 117.676Z",
    fill: "#8B5B57"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2387 83.2544H89.6502C89.4805 83.6891 89.3108 84.1215 89.1411 84.5562C89.1737 84.1215 89.2062 83.6891 89.2387 83.2544Z",
    fill: "#242828"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2285 83.5664H85.1016L83.1281 85.2076L82.2285 83.5664Z",
    fill: "#403430"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3032 87.0371L95.3265 91.7189L96.9536 88.1367L95.3032 87.0371Z",
    fill: "#73473B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9538 88.1362L95.3267 91.7185H96.998L96.9538 88.1362Z",
    fill: "#89584D"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0054 82.9292L67.5493 84.231L71.1732 84.152L67.0054 82.9292Z",
    fill: "#8B6151"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2938 84.2312L65.7476 83.4292L67.2724 83.5687L66.2938 84.2312Z",
    fill: "#725750"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2939 84.2309H67.5492L67.2725 83.5684L66.2939 84.2309Z",
    fill: "#724D46"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1289 87.3881L67.4004 87.1533V87.4369L66.1289 87.3881Z",
    fill: "#EBC3B8"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M63.063 87.9503L66.5102 88.0642L66.129 87.3877L63.063 87.9503Z",
    fill: "#AD796A"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5101 88.0642L67.4004 87.4365L66.1289 87.3877L66.5101 88.0642Z",
    fill: "#CFA294"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4794 85.9703L67.5492 84.2314H66.2939L67.4794 85.9703Z",
    fill: "#9C6E66"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M71.545 83.9868L67.333 84.0566C68.744 85.3095 70.1549 86.5602 71.5659 87.8132C71.5589 86.5369 71.5519 85.263 71.5473 83.9868H71.545Z",
    fill: "#B18879"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3906 85.8581L55.3878 85.793L58.5421 88.1362L54.3906 85.8581Z",
    fill: "#423735"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2382 87.4856C70.1526 87.4693 69.0671 87.453 67.9839 87.4367V84.5542C69.0694 85.5305 70.1549 86.5069 71.2382 87.4832V87.4856Z",
    fill: "#CAA08E"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5492 84.2314L68.1442 84.5848L67.4004 87.5533L67.5492 84.2314Z",
    fill: "#A9776B"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M68.214 87.4368H67.4004L68.1442 84.5845L68.214 87.4368Z",
    fill: "#BD8F7C"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6802 81.625L71.5453 84.5564V81.625H66.6802Z",
    fill: "#8E6354"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M56.508 82.2759L51.1431 85.4281L56.508 83.1406V82.2759Z",
    fill: "#7B5653"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5078 82.2759C56.8611 82.0597 57.2145 81.8412 57.5678 81.625C58.3348 81.8412 59.1043 82.0597 59.8713 82.2759H56.5078Z",
    fill: "#836A6E"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5078 81.625L61.5896 81.6413L59.8718 82.2759L57.5078 81.625Z",
    fill: "#47403D"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5855 69.9067L82.2285 71.9733L85.7292 76.0577L84.5855 69.9067Z",
    fill: "#D99F87"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2974 85.7002L95.3034 87.0369L95.3266 88.1364L93.2974 85.7002Z",
    fill: "#7E5650"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M84.748 86.3461L87.3422 86.3786L86.3752 85.8672L84.748 86.3461Z",
    fill: "#C4C5BF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1885 85.7907L88.8156 85.8582L88.6761 85.5327L87.1885 85.7907Z",
    fill: "#4F4A3D"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8159 85.8583L89.239 84.8471L88.9438 84.4473L88.8159 85.8583Z",
    fill: "#513F3D"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2386 84.8468V83.2544L88.9434 84.4469L89.2386 84.8468Z",
    fill: "#453431"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8157 85.8583L88.6763 85.5329L88.9436 84.4473L88.8157 85.8583Z",
    fill: "#705B5C"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8892 85.1006L86.0495 85.533L86.0681 85.1819L85.8892 85.1006Z",
    fill: "#9B9A9B"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M87.342 86.3789L87.5326 85.8047L86.375 85.8675L87.342 86.3789Z",
    fill: "#AFB4AD"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5324 85.8047L88.776 86.3603L87.3418 86.3789L87.5324 85.8047Z",
    fill: "#A7ABA4"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5327 85.8047L88.7763 86.3603L88.7577 85.8558L87.5327 85.8047Z",
    fill: "#9B928A"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0399 85.1538V85.7908H91.1543L92.0399 85.1538Z",
    fill: "#996967"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8877 87.4182H89.6083V86.7417L88.8877 87.4182Z",
    fill: "#A68374"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2305 86.8971L83.3537 86.7251L84.7484 86.3462L83.2305 86.8971Z",
    fill: "#AB8C7E"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0034 89.0365V84.2314L81.3288 85.5332L81.0034 89.0365Z",
    fill: "#453029"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0034 89.0359L81.6543 87.16L81.3288 85.5327L81.0034 89.0359Z",
    fill: "#5D3A30"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6304 87.4854C82.6072 86.9763 82.5816 86.4695 82.5584 85.9604L81.7285 87.0623C82.0307 87.2018 82.3306 87.3436 82.6327 87.4831L82.6304 87.4854Z",
    fill: "#785446"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M69.439 106.896L75.471 107.02L76.3101 108.475L69.439 106.896Z",
    fill: "#563B2E"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9336 107.822L76.1219 103.438L81.7099 108.301L75.9336 107.822Z",
    fill: "#D39E84"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9336 107.821L76.2079 108.3L81.0033 108.24L75.9336 107.821Z",
    fill: "#B18371"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1221 103.438H79.4158L78.4837 105.492L76.1221 103.438Z",
    fill: "#ECBCAC"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4155 103.438L79.5573 106.427L78.4834 105.492L79.4155 103.438Z",
    fill: "#DBA98F"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M79.416 103.438L80.4086 107.166L79.5578 106.427L79.416 103.438Z",
    fill: "#E3AB89"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M79.416 103.438L82.6308 106.692L80.2482 106.564L79.416 103.438Z",
    fill: "#D5A48F"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5843 106.645L82.6308 103.438L79.4741 103.498L82.5843 106.645Z",
    fill: "#CE977E"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4084 107.166L82.6306 106.692L80.248 106.564L80.4084 107.166Z",
    fill: "#AA7A69"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M75.936 107.768L75.2271 106.645H75.9825L75.936 107.768Z",
    fill: "#A97F75"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6304 106.691L81.7099 108.3L80.4082 107.166L82.6304 106.691Z",
    fill: "#8F6961"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2271 106.645L76.122 103.438L75.9825 106.645H75.2271Z",
    fill: "#DCA491"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1221 103.437L77.0983 101.159V103.437H76.1221Z",
    fill: "#FDDDCC"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0981 101.826L77.8745 103.437H77.0981V101.826Z",
    fill: "#F7E0D0"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0981 101.826H77.9559L77.8745 103.437L77.0981 101.826Z",
    fill: "#FCE2D6"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9559 101.826L78.7253 103.437H77.749C77.8188 102.9 77.8885 102.363 77.9559 101.826Z",
    fill: "#F5D0C5"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9561 101.826H78.7255V103.437L77.9561 101.826Z",
    fill: "#F6D1C6"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4082 103.479L82.6304 100.183V103.437L80.4082 103.479Z",
    fill: "#E1A287"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2267 106.645C74.7641 106.118 74.3039 105.592 73.8413 105.064V106.692C74.3039 106.675 74.7641 106.659 75.2267 106.645Z",
    fill: "#C69185"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2268 106.645L75.4709 107.019L69.3784 106.896L75.2268 106.645Z",
    fill: "#936860"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0981 101.159L77.9559 101.826H77.0981V101.159Z",
    fill: "#FEE5D1"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0981 101.159L77.9559 101.038V101.826L77.0981 101.159Z",
    fill: "#FEE5D1"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9561 101.038L78.7255 101.826H77.9561V101.038Z",
    fill: "#FDDDD4"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6304 106.692L84.1692 105.064V106.645L82.6304 106.692Z",
    fill: "#8A5845"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6305 103.438L84.1693 103.479L82.5933 106.12L82.6305 103.438Z",
    fill: "#B8866E"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4951 106.929L82.6299 106.692L84.1687 106.645L82.4951 106.929Z",
    fill: "#684137"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4955 106.929C83.0836 106.959 83.6717 106.989 84.2574 107.017C84.2272 106.894 84.197 106.768 84.1668 106.645L82.4932 106.929H82.4955Z",
    fill: "#5F3D35"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1692 105.064L82.5444 106.12C82.5723 106.42 82.6026 106.72 82.6304 107.017C83.1418 106.366 83.6555 105.715 84.1669 105.064H84.1692Z",
    fill: "#8F5E4B"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1692 103.479V105.064L82.5444 106.12L84.1692 103.479Z",
    fill: "#A1755F"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6304 100.183L84.1692 103.479L82.6304 103.437V100.183Z",
    fill: "#C58A71"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M82.63 100.183L80.3521 98.8809L80.4078 103.479L82.63 100.183Z",
    fill: "#DEA586"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3521 98.8809H81.9443L82.63 100.183L80.3521 98.8809Z",
    fill: "#DEA285"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9448 98.8808L83.9346 98.2275L83.8858 99.9431L81.9448 98.8808Z",
    fill: "#B37D63"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9448 98.8809L82.5934 100.108L83.8858 99.9432L81.9448 98.8809Z",
    fill: "#C68B71"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3521 98.8808H81.9443L83.9341 98.2275L80.3521 98.8808Z",
    fill: "#D59272"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M83.934 98.2276L82.3045 94.3223L82.272 98.5298L83.934 98.2276Z",
    fill: "#B47D66"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7251 101.826L79.4736 103.498L78.7251 103.437V101.826Z",
    fill: "#F4C5B7"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7251 101.826L79.4736 101.896C79.441 102.41 79.4085 102.923 79.376 103.437C79.1598 102.9 78.9413 102.363 78.7251 101.826Z",
    fill: "#E6B8A0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4739 101.896L77.9561 101.038L78.7255 101.826L79.4739 101.896Z",
    fill: "#F6C8BA"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9561 101.038C77.8863 100.211 77.8166 99.3832 77.7492 98.5557C77.2076 98.6649 76.6637 98.7719 76.1221 98.8811L77.9584 101.038H77.9561Z",
    fill: "#F6CFBA"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4738 101.896L77.749 98.8809L77.9559 101.038L79.4738 101.896Z",
    fill: "#F7CEBD"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M79.474 101.896L79.4159 98.7905C78.7511 98.7114 78.0886 98.6347 77.4238 98.5557C78.1072 99.6692 78.7906 100.783 79.474 101.898V101.896Z",
    fill: "#FBCBBA"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8623 105.302L75.6312 105.192L75.2268 106.645L73.8623 105.302Z",
    fill: "#D79F8D"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8416 105.064C73.0094 105.648 72.1749 106.229 71.3428 106.813L73.8602 106.703C73.8532 106.157 73.8462 105.611 73.8416 105.064Z",
    fill: "#D7A293"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M69.439 106.896L69.611 105.715L71.345 106.813L69.439 106.896Z",
    fill: "#945F4E"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6108 105.715L73.7902 105.301L71.3449 106.812L69.6108 105.715Z",
    fill: "#AA7768"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3528 98.8812L79.416 98.7905L80.4086 103.479L80.3528 98.8812Z",
    fill: "#E1BDA6"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3046 94.3223L80.3521 98.8809L82.2721 98.5298L82.3046 94.3223Z",
    fill: "#D79C7C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M79.416 98.7902L80.6782 94.3223H82.3053L79.416 98.7902Z",
    fill: "#C58B73"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M79.416 98.7902L80.3528 98.8809L82.3053 94.3223L79.416 98.7902Z",
    fill: "#D8A286"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9346 98.2277V92.3696L82.3052 94.3223L83.9346 98.2277Z",
    fill: "#966953"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6861 93.8666L82.5443 90.0938L80.6777 94.3223L82.6861 93.8666Z",
    fill: "#B37A68"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6777 94.3223L82.6861 93.8667L82.3049 94.3223H80.6777Z",
    fill: "#BA7E6B"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5444 90.0938L83.9345 92.3696L82.6862 93.8666L82.5444 90.0938Z",
    fill: "#A07360"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5444 90.0938H84.0367L83.9345 92.3696L82.5444 90.0938Z",
    fill: "#C49783"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6776 94.3223L78.8203 94.6128L79.4154 98.7902L80.6776 94.3223Z",
    fill: "#E9B198"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M81.024 93.5412C81.0054 93.6714 80.8613 90.0938 80.8613 90.0938H82.5466L81.024 93.5412Z",
    fill: "#BD7F6E"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5442 90.0938L81.7284 89.0361L80.8613 90.0938H82.5442Z",
    fill: "#A37168"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5329 87.418L81.6543 88.1363C81.6775 88.4362 81.7031 88.736 81.7264 89.0336L82.5329 87.418Z",
    fill: "#84635C"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7284 89.0358L81.0519 88.894L80.8613 90.0936L81.7284 89.0358Z",
    fill: "#A16D5C"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8623 105.301L76.1217 98.8809V103.437L73.8623 105.301Z",
    fill: "#E4AC8E"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8623 105.302L75.6312 105.193L76.1217 103.438L73.8623 105.302Z",
    fill: "#E0B091"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1216 98.8809L70.1431 100.108L73.8622 105.301L76.1216 98.8809Z",
    fill: "#E1A989"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8208 94.6133L76.1221 98.8813L79.4158 98.7906L78.8208 94.6133Z",
    fill: "#F5C6B1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8203 94.6128L80.8612 90.0938L81.0239 93.5412L78.8203 94.6128Z",
    fill: "#DBA287"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0239 93.5415L80.6776 94.3226L78.8203 94.6132L81.0239 93.5415Z",
    fill: "#E8AC8C"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1219 98.8811L75.9336 92.3535L78.8206 94.6131L76.1219 98.8811Z",
    fill: "#F7C4AE"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8615 90.0938L77.749 90.2588L78.8206 94.6128L80.8615 90.0938Z",
    fill: "#E0A98D"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M77.749 90.2585L77.6514 85.7905L80.8615 90.0934L77.749 90.2585Z",
    fill: "#E4AD90"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6514 85.7913L79.3041 84.2314L79.4156 88.1577L77.6514 85.7913Z",
    fill: "#E2AB90"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0518 88.8943L81.6538 87.1602L81.7282 89.0361L81.0518 88.8943Z",
    fill: "#74534F"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0521 88.8947L81.0032 84.2314L80.1455 87.6696L81.0521 88.8947Z",
    fill: "#855843"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3042 84.2314H81.0034L80.1457 87.6696L79.3042 84.2314Z",
    fill: "#8D6955"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1457 87.6696L79.4158 88.1577L79.3042 84.2314L80.1457 87.6696Z",
    fill: "#C28476"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1455 87.6694L80.8614 90.094L81.0521 88.8945L80.1455 87.6694Z",
    fill: "#AF7966"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M79.416 88.1576L80.1459 87.6694L80.8618 90.094L79.416 88.1576Z",
    fill: "#CC8E7C"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M77.749 90.2588L75.9336 92.3533L78.8206 94.6128L77.749 90.2588Z",
    fill: "#F6C6AF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6514 85.7905L75.9336 92.353L77.749 90.2585L77.6514 85.7905Z",
    fill: "#FCCDBB"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6514 85.7905L75.9336 85.8045V92.353L77.6514 85.7905Z",
    fill: "#F0BFAA"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5327 87.418L84.0367 90.0936H82.5443L82.5327 87.418Z",
    fill: "#D99F98"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1693 106.645C84.8504 106.552 85.5315 106.459 86.2126 106.366C85.4525 105.174 84.6923 103.979 83.9346 102.786C84.0136 104.072 84.0903 105.359 84.1693 106.645Z",
    fill: "#7C5746"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0522 106.306L83.8857 102.875L83.9346 96.4263L86.0522 106.306Z",
    fill: "#9B684F"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9333 92.3535L70.1431 100.108L76.1216 98.8811L75.9333 92.3535Z",
    fill: "#E3AE90"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1434 100.108L67.3447 105.062L73.8626 105.302L70.1434 100.108Z",
    fill: "#EEB79F"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3447 105.062L69.6111 105.715L73.8626 105.301L67.3447 105.062Z",
    fill: "#E4A68B"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4391 106.896L67.3447 106.787L69.6111 105.715L69.4391 106.896Z",
    fill: "#AF7463"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3447 106.787V105.062L69.6111 105.715L67.3447 106.787Z",
    fill: "#BE8473"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0523 106.306L86.8286 109.623L84.1694 106.646L86.0523 106.306Z",
    fill: "#4D372D"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8286 109.623L87.2982 104.778L86.0522 106.306L86.8286 109.623Z",
    fill: "#633932"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2979 104.778L85.7847 105.064L86.052 106.306L87.2979 104.778Z",
    fill: "#774944"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5144 104.739C86.7822 104.116 86.0476 103.495 85.3154 102.872L85.785 105.064C86.3614 104.955 86.9379 104.848 87.5144 104.739Z",
    fill: "#92605A"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9346 96.4261L85.7988 92.3696H83.9346V96.4261Z",
    fill: "#BF7E69"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7988 92.3696L85.5617 88.4619L83.9346 92.3696H85.7988Z",
    fill: "#D5A08D"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5617 88.4619L84.0368 90.0938L83.9346 92.3696L85.5617 88.4619Z",
    fill: "#D19F8D"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5615 88.4617L82.5327 87.418L84.0367 90.0936L85.5615 88.4617Z",
    fill: "#D6A29A"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5141 104.739C86.6889 102.521 85.8638 100.306 85.0386 98.0884L85.3152 102.872C86.0474 103.495 86.7819 104.116 87.5141 104.739Z",
    fill: "#C58A76"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2362 93.3461C85.9963 97.1445 86.7564 100.943 87.5141 104.739C86.6889 102.521 85.8638 100.306 85.0386 98.0883C85.1037 96.5076 85.1687 94.9268 85.2338 93.3438L85.2362 93.3461Z",
    fill: "#CC8D76"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9109 107.019C83.8439 107.447 82.777 107.873 81.7124 108.3L82.4981 106.931C83.3023 106.961 84.1066 106.992 84.9132 107.019H84.9109Z",
    fill: "#745048"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8283 109.623C85.7544 108.862 84.6828 108.102 83.6089 107.344C83.9343 107.235 84.2597 107.128 84.5852 107.019C85.3336 107.886 86.0798 108.756 86.8283 109.623Z",
    fill: "#413630"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8287 109.623H85.7245L83.665 107.326L86.8287 109.623Z",
    fill: "#614636"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4951 106.929L82.6299 106.692L84.1687 106.645L82.4951 106.929Z",
    fill: "#684137"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9346 107.019L84.1693 106.647C84.3088 106.771 84.446 106.896 84.5854 107.019H83.9346Z",
    fill: "#52342F"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0508 109.623H86.1683L82.3864 111.157L79.0508 109.623Z",
    fill: "#4E3F36"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0508 109.623C79.16 110.058 79.267 110.49 79.3762 110.925H82.9559C81.6542 110.49 80.3525 110.058 79.0508 109.623Z",
    fill: "#7F5F52"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0509 109.623C78.0746 109.188 77.0983 108.756 76.1221 108.321C76.5567 108.863 76.9891 109.407 77.4238 109.949L79.0509 109.623Z",
    fill: "#7E5C52"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3764 110.925L77.4238 109.949L79.051 109.623L79.3764 110.925Z",
    fill: "#8C6658"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8003 110.925L85.7849 110.953L86.8286 109.623L82.8003 110.925Z",
    fill: "#8D6A5B"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9216 109.623H86.1685L82.8003 110.925L86.9216 109.623Z",
    fill: "#734F3D"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4238 109.949H76.1221V108.321C76.5567 108.863 76.9891 109.407 77.4238 109.949Z",
    fill: "#AC887D"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M76.122 109.949C75.4711 109.298 74.8203 108.647 74.1694 107.996C74.8505 108.098 75.5293 108.198 76.2103 108.301L76.1243 109.949H76.122Z",
    fill: "#C09E8E"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1217 108.321C74.9944 108.314 73.8647 108.307 72.7373 108.3L72.8744 107.687C73.9577 107.898 75.0385 108.11 76.1217 108.321Z",
    fill: "#8A7669"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7373 108.3L69.6108 108.477V107.673C70.6522 107.882 71.6936 108.094 72.7373 108.303V108.3Z",
    fill: "#D4B7A8"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8745 107.687L69.8388 107.768L69.439 106.896L72.8745 107.687Z",
    fill: "#9B756A"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6108 107.67C70.6522 107.879 71.6936 108.091 72.7373 108.3L72.8744 107.686C71.7866 107.682 70.6987 107.675 69.6108 107.67Z",
    fill: "#BBA595"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7134 107.496L67.3447 106.787L69.4391 106.896L69.7134 107.496Z",
    fill: "#AC816E"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6005 106.864L67.7655 107.496C69.1393 107.663 70.513 107.828 71.8868 107.996C70.4573 107.619 69.0277 107.243 67.5981 106.866L67.6005 106.864Z",
    fill: "#E6BDA8"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3568 108.331V111.957H67.3447L71.3568 108.331Z",
    fill: "#DCBCAB"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5438 108.321L71.3569 111.957V108.331L74.5438 108.321Z",
    fill: "#D8C1B8"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5438 108.321L74.4926 112.227L71.3569 111.957L74.5438 108.321Z",
    fill: "#DCC1BA"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4922 112.227L76.1216 109.949L74.5433 108.321L74.4922 112.227Z",
    fill: "#D2AC9E"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9339 85.8047L74.8042 93.8665L75.9339 92.3532V85.8047Z",
    fill: "#F0BCA1"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8176 93.9971C74.6781 91.2308 74.541 88.4621 74.4015 85.6958L70.1431 100.109C71.7005 98.0721 73.2602 96.0334 74.8176 93.9971Z",
    fill: "#E4AC89"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4043 85.6958L75.9338 85.8051C75.9338 85.8051 74.7902 93.8599 74.8041 93.7646C74.8181 93.6693 74.4043 85.6958 74.4043 85.6958Z",
    fill: "#E1AD95"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4043 85.6958L76.1221 81.4185L75.9338 85.805L74.4043 85.6958Z",
    fill: "#BF8A75"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1219 81.4185L79.3041 84.2313L75.9336 85.805L76.1219 81.4185Z",
    fill: "#E4AE99"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6514 85.7913L79.3041 84.2314L75.9336 85.8052L77.6514 85.7913Z",
    fill: "#DAA792"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3042 84.2311L81.0034 79.1982V84.2311H79.3042Z",
    fill: "#B07C68"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5987 80.3979H79.304C79.304 80.3979 79.2319 84.2313 79.304 84.2313C79.3761 84.2313 80.5987 80.3979 80.5987 80.3979Z",
    fill: "#CA9077"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3043 80.3976L79.4158 76.7852L76.1221 81.4181L79.3043 84.231V80.3976Z",
    fill: "#DDAB91"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0034 79.1981L79.4158 76.7852L79.3042 80.3976L81.0034 79.1981Z",
    fill: "#D19A84"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3042 80.3977H80.5989L81.0034 79.1982L79.4158 80.3187",
    fill: "#C3917D"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M79.416 76.7852L81.0246 77.1734L81.0036 79.1981L79.416 76.7852Z",
    fill: "#CA9E8A"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4158 76.7852L77.0983 77.0688L76.7915 80.4743L79.4158 76.7852Z",
    fill: "#DCA890"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4039 85.6958L72.7373 85.8585L72.9721 90.5357L74.4039 85.6958Z",
    fill: "#D1997E"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7373 85.8582C72.8675 85.5327 72.9256 81.625 72.9256 81.625L74.4039 83.6312L72.7373 85.8582Z",
    fill: "#AF7C67"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7373 85.8584L74.4039 83.6313V85.6956L72.7373 85.8584Z",
    fill: "#B88370"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4609 84.9818H72.4884L71.5446 81.625L71.4609 84.9818Z",
    fill: "#996759"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4609 84.9819L72.7371 85.8583L72.4884 84.9819H71.4609Z",
    fill: "#C7927E"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4009 85.7119L72.8978 89.0733L72.7375 85.8584L71.4009 85.7119Z",
    fill: "#D2AA92"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4012 85.7123L70.9131 89.4387C71.5756 89.3155 72.238 89.1946 72.8982 89.0714L71.4012 85.71V85.7123Z",
    fill: "#EBBBA7"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1733 89.3174L71.4011 95.8519L72.9725 90.5355L71.1733 89.3174Z",
    fill: "#E7AD90"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1733 89.3173L72.8981 89.0732L72.9725 90.5354L71.1733 89.3173Z",
    fill: "#D89E84"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1731 89.3172L69.3438 87.418C69.976 87.4412 70.6059 87.4621 71.2382 87.4854C71.2173 88.0968 71.194 88.7058 71.1731 89.3172Z",
    fill: "#DBAF9D"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5102 88.0642C65.3735 89.0661 64.2368 90.0657 63.1002 91.0677C63.0886 90.0285 63.0746 88.9917 63.063 87.9526L66.5125 88.0665L66.5102 88.0642Z",
    fill: "#C38D7C"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2139 87.4366L69.3436 87.418L71.1729 89.3172L68.2139 87.4366Z",
    fill: "#D8AA97"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1733 89.3176L68.1445 90.2591L68.2143 87.437L71.1733 89.3176Z",
    fill: "#E0B6A3"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6577 89.8032L69.6949 96.3308L71.4011 95.8519L69.6577 89.8032Z",
    fill: "#EEB89D"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6948 96.3309L70.1435 100.108L71.401 95.8521L69.6948 96.3309Z",
    fill: "#E7AA8E"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1443 90.2588C68.0908 92.3719 68.0373 94.4873 67.9839 96.6004C68.5534 96.0076 69.1252 95.4148 69.6947 94.8244L68.1443 90.2588Z",
    fill: "#F6C2B6"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3095 89.1126C66.4638 89.7635 64.6205 90.4144 62.7749 91.0653C63.6187 90.4005 64.4625 89.7356 65.3063 89.0708C66.3081 89.0847 67.3076 89.0987 68.3095 89.1126Z",
    fill: "#C79888"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4922 112.226L76.1216 109.948L77.4233 112.545L74.4922 112.226Z",
    fill: "#CBA28A"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4238 112.545L79.3763 110.925L76.1221 109.948L77.4238 112.545Z",
    fill: "#CD9F8B"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1221 109.948L79.3763 110.925L77.4238 109.948H76.1221Z",
    fill: "#D4A18D"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0742 111.901C79.4852 111.576 80.8961 111.25 82.3071 110.925H79.3782C78.9436 111.25 78.5112 111.576 78.0765 111.901H78.0742Z",
    fill: "#BA9686"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5586 85.9607L83.1281 85.2075L82.5749 86.6906L82.5586 85.9607Z",
    fill: "#634B41"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5747 86.6906L83.1279 87.037V85.2075L82.5747 86.6906Z",
    fill: "#534639"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6235 87.4507L83.2302 86.8975L84.5459 87.4182L82.6235 87.4507Z",
    fill: "#B7826A"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5459 87.418L85.5617 88.4617L82.6235 87.4505L84.5459 87.418Z",
    fill: "#C89B89"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5612 88.4617L85.7983 87.4854L84.5454 87.418L85.5612 88.4617Z",
    fill: "#D3A497"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7988 87.4855L83.7998 86.6904L84.546 87.418L85.7988 87.4855Z",
    fill: "#BB968A"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2305 86.8973L83.8 86.6904L84.5461 87.418L83.2305 86.8973Z",
    fill: "#B48571"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6403 86.9187L87.3423 86.3794L84.4507 86.9187H86.6403Z",
    fill: "#BDAFA8"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7765 86.3604L85.7988 87.4855L87.3423 86.3789L88.7765 86.3604Z",
    fill: "#BDB0AB"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7988 87.4855L87.9211 87.4181L88.7765 86.3604L85.7988 87.4855Z",
    fill: "#B39088"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7763 86.3604L88.8158 87.4855L87.9209 87.4181L88.7763 86.3604Z",
    fill: "#AF817A"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8679 87.7734L87.3421 89.4472L85.5615 88.4615L86.8679 87.7734Z",
    fill: "#B2866D"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3193 88.8823L86.2124 90.0888L87.3421 89.4472L86.3193 88.8823Z",
    fill: "#B7826A"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2123 90.0894L86.3122 88.9619L85.5986 89.0735L86.2123 90.0894Z",
    fill: "#C9957F"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5986 89.0732L85.7985 92.3696L86.2123 90.0891L85.5986 89.0732Z",
    fill: "#CB9784"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7222 86.3579L85.8314 86.6624L87.3423 86.3788L85.7222 86.3579Z",
    fill: "#CCBDB6"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8159 87.4854L90.1571 87.418L90.199 86.1836L88.8159 87.4854Z",
    fill: "#A68072"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1544 85.7905L90.1572 86.5088V87.4178L91.1544 85.7905Z",
    fill: "#AA7A70"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1572 87.4178H92.0401L91.1544 85.7905L90.1572 87.4178Z",
    fill: "#93635A"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1543 85.7905H92.0097L91.7215 86.8343L91.1543 85.7905Z",
    fill: "#7B564C"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0094 85.7905L92.3279 87.4178L91.7212 86.8343L92.0094 85.7905Z",
    fill: "#755248"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0396 87.4184H92.3279L91.7212 86.835L92.0396 87.4184Z",
    fill: "#6B4A40"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3282 87.4181L93.1092 85.8048L92.0098 85.7583L92.3282 87.4181Z",
    fill: "#7A524A"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1091 85.8047L92.8349 87.4854L92.3281 87.418L93.1091 85.8047Z",
    fill: "#745248"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M92.835 87.4858L93.3952 88.1367L93.2975 85.9492L92.835 87.4858Z",
    fill: "#946861"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1092 85.8047L93.2975 85.9488L92.835 87.4854L93.1092 85.8047Z",
    fill: "#8E5F59"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8682 87.7739C87.0843 87.5693 87.3005 87.3647 87.5144 87.1602C87.9583 87.2694 88.4023 87.3763 88.8463 87.4856L86.8682 87.7739Z",
    fill: "#9B7569"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8682 87.7741L88.7766 88.2716L88.8161 87.4858L86.8682 87.7741Z",
    fill: "#9C6B62"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7766 88.2709L87.1285 88.6893L86.8682 87.7734L88.7766 88.2709Z",
    fill: "#B18472"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7765 88.271V89.073L87.1284 88.6894L88.7765 88.271Z",
    fill: "#B2826D"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4059 90.089L92.0401 87.418H90.1572L90.4059 90.089Z",
    fill: "#83554A"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0401 87.418L92.2703 89.0731L90.6733 89.6496L92.0401 87.418Z",
    fill: "#725245"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2703 89.0732L93.049 90.0891L90.6733 89.6498L92.2703 89.0732Z",
    fill: "#9C7268"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0487 90.0893H90.4058L90.6731 89.6499L93.0487 90.0893Z",
    fill: "#8E6A5A"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8349 87.4858L93.0487 90.0894L92.27 89.0736L92.8349 87.4858Z",
    fill: "#886256"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0488 90.0894L94.9758 87.8787L92.835 87.4858L93.0488 90.0894Z",
    fill: "#9B6C62"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9754 87.8784L95.3264 91.7187L93.9922 89.0059L94.9754 87.8784Z",
    fill: "#996763"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0483 90.0891L95.3263 91.7187L93.9921 89.0059L93.0483 90.0891Z",
    fill: "#A37469"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9756 88.1362H95.3266V91.7185L94.9756 88.1362Z",
    fill: "#97635E"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M96.998 91.7188L96.6284 95.2987L95.3267 91.7188H96.998Z",
    fill: "#6F473D"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3267 91.7188V96.6005L96.6284 95.2987L95.3267 91.7188Z",
    fill: "#6B4B3F"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3267 96.6006L96.6284 98.8811V95.2988L95.3267 96.6006Z",
    fill: "#4E3328"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3267 96.6006V98.7671L96.6284 98.8811L95.3267 96.6006Z",
    fill: "#5B372E"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3264 98.7666V100.833L93.6992 101.81L95.3264 98.7666Z",
    fill: "#6A463E"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3264 100.833L95.0009 103.437L93.6992 101.81L95.3264 100.833Z",
    fill: "#563E37"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6992 101.81V103.393L95.0009 103.437L93.6992 101.81Z",
    fill: "#52362E"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6995 101.81H91.2402L91.0938 103.437L93.6995 101.81Z",
    fill: "#8A5F53"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3285 103.432L91.0938 105.389L93.6995 103.393L91.3285 103.432Z",
    fill: "#765246"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6995 103.393L93.3741 105.389H91.0938L93.6995 103.393Z",
    fill: "#6F493F"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0938 103.437L91.3285 103.433L91.0938 105.39V103.437Z",
    fill: "#89635C"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6995 98.7666L91.2402 101.81H93.6995V98.7666Z",
    fill: "#95685A"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6992 98.8809C94.2408 97.3606 94.7847 95.8426 95.3264 94.3223V98.767C94.7847 98.8042 94.2408 98.8437 93.6992 98.8809Z",
    fill: "#845851"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3263 94.322L93.0483 90.0889L95.3263 91.7184V94.322Z",
    fill: "#A4756F"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M93.567 91.0513L93.374 94.322H95.3266L93.567 91.0513Z",
    fill: "#A17066"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5672 91.0513L91.7866 90.0889H93.0488L93.5672 91.0513Z",
    fill: "#A7786C"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7866 90.0889L91.7471 91.393L93.5671 91.0513L91.7866 90.0889Z",
    fill: "#B17E6F"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4058 90.0889V90.6677L91.7865 90.0889H90.4058Z",
    fill: "#9F6F5F"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1177 90.7422C90.6593 90.9584 91.2032 91.1769 91.7448 91.3931L91.7866 90.0913C91.2311 90.3075 90.6732 90.526 90.1177 90.7422Z",
    fill: "#AC7968"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7466 91.3933L89.0781 92.0395L90.3473 90.668L91.7466 91.3933Z",
    fill: "#BC8370"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7764 89.0732L89.0785 92.0395L90.4058 90.0891L88.7764 89.0732Z",
    fill: "#AC7868"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4054 90.0889V90.6677L89.0781 92.0392L90.4054 90.0889Z",
    fill: "#AE7B6B"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7471 91.393L93.3742 94.322L93.5671 91.0513L91.7471 91.393Z",
    fill: "#B9806C"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6284 98.8805L95.3267 100.833V98.7666L96.6284 98.8805Z",
    fill: "#4A3A30"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0012 103.437L93.374 105.389L93.6994 103.393L95.0012 103.437Z",
    fill: "#3E352A"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6994 98.8135L88.4902 98.8809L88.9621 103.433L93.6994 98.8135Z",
    fill: "#AA7968"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9619 103.433L91.0935 103.437L91.2724 101.18L88.9619 103.433Z",
    fill: "#9B6C60"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0781 92.0392L91.212 93.1062L91.2724 91.5068L89.0781 92.0392Z",
    fill: "#BD826D"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2124 93.1068L93.3742 94.3226L91.747 91.3936L91.2124 93.1068Z",
    fill: "#BD8371"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2728 91.5075L91.747 91.3936L91.2124 93.1068L91.2728 91.5075Z",
    fill: "#C28672"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9619 103.433L91.0935 105.39V103.437L88.9619 103.433Z",
    fill: "#8B635D"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0938 105.39L91.4215 108.321L93.3741 105.39H91.0938Z",
    fill: "#734739"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9624 103.433C88.9624 103.433 88.8159 108.644 88.8159 108.319C88.8159 107.994 91.0939 105.39 91.0939 105.39L88.9624 103.433Z",
    fill: "#997062"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4213 108.321L89.6338 111.413L91.0936 105.39L91.4213 108.321Z",
    fill: "#714236"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4902 107.67C88.8714 108.918 89.2527 110.167 89.6339 111.413L91.0936 105.39C90.2266 106.15 89.3573 106.91 88.4902 107.668V107.67Z",
    fill: "#8D574F"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4903 98.8809L87.2979 103.498L88.9622 103.432L88.4903 98.8809Z",
    fill: "#C28577"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4903 98.8809L86.375 99.0436L87.2978 103.498L88.4903 98.8809Z",
    fill: "#D1907A"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2979 103.498L88.911 105.302L88.9622 103.433L87.2979 103.498Z",
    fill: "#C27F75"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2979 103.498L87.3048 105.064L88.911 105.301L87.2979 103.498Z",
    fill: "#CC8B75"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3047 105.064L88.8342 107.821L88.9109 105.302L87.3047 105.064Z",
    fill: "#BB7F6A"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8342 107.821L87.3489 107.429L87.3047 105.064L88.8342 107.821Z",
    fill: "#AE785F"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M86.375 99.0434L88.8761 94.3965L88.4903 98.8807L86.375 99.0434Z",
    fill: "#C2866F"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8761 94.3968L85.229 93.5088L86.375 99.0437L88.8761 94.3968Z",
    fill: "#C98974"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2124 90.0889L89.0785 92.0392L88.8088 94.2895L86.2124 90.0889Z",
    fill: "#CB937E"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M87.626 88.8057L88.7766 89.073L89.0788 92.0392L87.626 88.8057Z",
    fill: "#BB826B"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3491 107.429L88.8345 107.822L89.297 110.139L87.3491 107.429Z",
    fill: "#AF726C"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M40.941 102.091L37.8727 72.6729L34.73 86.1929L40.941 102.091Z",
    fill: "#CA9276"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3291 93.3457L32.9893 113.04L40.9413 102.091L32.3291 93.3457Z",
    fill: "#C89B82"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9888 113.04L44.0579 125.737L40.9408 102.091L32.9888 113.04Z",
    fill: "#D0A891"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9409 102.091L51.5452 113.691L44.058 125.737L40.9409 102.091Z",
    fill: "#D9AFA0"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9859 116.785C49.0046 105.808 44.0209 94.8313 39.0396 83.8521L40.9433 102.091C45.2924 106.989 49.6392 111.887 53.9882 116.785H53.9859Z",
    fill: "#CFA895"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7767 107.019C45.1412 95.5706 41.5057 84.1218 37.8726 72.6753L39.0394 83.8545C42.2867 91.5769 45.5317 99.2993 48.779 107.022L48.7767 107.019Z",
    fill: "#D09F82"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8726 72.6729C39.337 68.821 40.8014 64.9691 42.2681 61.1172C42.2007 69.9066 42.1333 78.6961 42.0682 87.4855L37.8749 72.6729H37.8726Z",
    fill: "#BB8774"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3095 98.4438L62.8958 101.189L59.272 112.227L68.3095 98.4438Z",
    fill: "#D69F86"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0659 87.4858L47.6005 92.5861L48.4489 106.306L42.0659 87.4858Z",
    fill: "#DFAA99"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6006 92.5859L41.7197 79.998L42.0661 87.4857L47.6006 92.5859Z",
    fill: "#DBAA91"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M42.48 81.625H49.3209L49.8858 87.1739L42.48 81.625Z",
    fill: "#C49881"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8858 87.1739L47.6008 92.5857L42.48 81.625L49.8858 87.1739Z",
    fill: "#E1B5A3"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6006 92.5861L54.3904 89.3292L49.8855 87.1743L47.6006 92.5861Z",
    fill: "#E4BAAF"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8853 87.1743L54.3111 87.5532L54.3901 89.3292L49.8853 87.1743Z",
    fill: "#DDB8AB"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8254 84.7451C53.8789 85.768 53.9323 86.7885 53.9858 87.8113C52.5005 87.5998 51.0151 87.3859 49.5298 87.1744L53.8254 84.7451Z",
    fill: "#BE9285"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M54.311 87.5527L54.3901 89.3288L58.5416 88.1362L54.311 87.5527Z",
    fill: "#B88E7F"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4258 90.7958L68.1445 95.9495L68.177 88.9175L63.4258 90.7958Z",
    fill: "#E8BA9C"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1445 95.6172L69.695 96.3309L68.3096 98.4439L68.1445 95.6172Z",
    fill: "#E9B89A"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1442 95.6172L62.8955 101.189L68.3092 98.4439L68.1442 95.6172Z",
    fill: "#F1C4B6"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3511 90.7056L62.8955 101.19L68.1442 95.6175L63.3511 90.7056Z",
    fill: "#FAD3C8"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8959 101.189L54.3906 89.3286L63.3515 90.7048L62.8959 101.189Z",
    fill: "#E6B9AB"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3906 89.3286V99.4942L62.8959 101.189L54.3906 89.3286Z",
    fill: "#EBC0B7"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3904 99.4947L47.6006 92.5859L54.3904 93.5088V99.4947Z",
    fill: "#F5C4B8"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6006 92.5854L54.3904 89.3286V93.5083L47.6006 92.5854Z",
    fill: "#E9BDAB"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3904 99.4947L48.449 106.306L47.6006 92.5859L54.3904 99.4947Z",
    fill: "#DFB1A1"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4492 106.306L62.8958 101.189L54.3906 99.4946L48.4492 106.306Z",
    fill: "#DDB6AA"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4492 106.306L51.5454 113.691L62.8958 101.189L48.4492 106.306Z",
    fill: "#DAAD9B"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5454 113.691L59.272 112.227L62.8958 101.189L51.5454 113.691Z",
    fill: "#DEAC9A"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5454 113.691L56.1014 121.179L59.272 112.227L51.5454 113.691Z",
    fill: "#D9AC9A"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1007 121.179L44.0576 125.738L51.5448 113.691L56.1007 121.179Z",
    fill: "#D7B0A4"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 117.44L65.7641 118.619L68.5279 117.596L61.7241 117.44Z",
    fill: "#92685E"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3332 111.901C68.6744 111.92 70.0156 111.939 71.3569 111.957L64.4834 114.524C65.4341 113.649 66.3825 112.775 67.3332 111.901Z",
    fill: "#D8BCAE"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7639 118.619L62.8955 124.863L72.7373 124.036L65.7639 118.619Z",
    fill: "#E2AE8F"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7998 117.676C82.744 119.549 82.6882 121.423 82.6301 123.294C81.7909 123.343 80.9495 123.39 80.1104 123.438L82.7998 117.673V117.676Z",
    fill: "#6D4C45"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8958 124.863L59.8438 120.04L65.7619 118.617L62.8958 124.863Z",
    fill: "#E1B1A4"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7639 118.62L56.1011 121.179L61.1661 116.948L65.7639 118.62Z",
    fill: "#C9A393"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M56.101 121.179C56.101 121.179 62.8559 124.968 62.8954 124.863C62.9349 124.759 60.0595 120.128 60.0595 120.128L56.0986 121.179H56.101Z",
    fill: "#D5AB9C"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M62.896 124.863C62.9378 124.759 52.5195 131.595 52.5195 131.595L56.0992 121.179L62.8937 124.863H62.896Z",
    fill: "#D1A99C"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7275 124.598C64.5113 125.791 64.2928 126.986 64.0767 128.178C65.9502 126.883 67.8214 125.586 69.6949 124.292C68.0399 124.394 66.3849 124.496 64.7298 124.598H64.7275Z",
    fill: "#D59F93"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4832 127.407L52.5215 131.598L64.9086 124.866L64.4832 127.407Z",
    fill: "#D9B5AB"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4834 127.618L66.3407 129.948V126.389L64.4834 127.618Z",
    fill: "#E0B4A3"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7499 126.388H66.3403L69.6945 124.292L70.7499 126.388Z",
    fill: "#C49286"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3403 129.948L70.7499 126.389H66.3403V129.948Z",
    fill: "#E0B2A8"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3405 129.948L52.5215 131.598L64.4832 127.407L66.3405 129.948Z",
    fill: "#D6B0A7"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0576 125.737L52.521 131.598L56.1007 121.179L44.0576 125.737Z",
    fill: "#CEA99C"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1011 121.179L59.2717 112.227H67.3446L56.1011 121.179Z",
    fill: "#CFB19F"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7295 63.6905L50.9595 55.3125L44.5718 71.1921L40.7295 63.6905Z",
    fill: "#D0947B"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9594 55.3125L49.3207 81.625L44.5718 71.1921L50.9594 55.3125Z",
    fill: "#D09A7B"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9644 63.7207C42.1963 61.3263 43.4283 58.9296 44.6603 56.5353L50.9596 55.3125C47.6286 58.116 44.2977 60.9195 40.9644 63.7207Z",
    fill: "#A17C68"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9596 55.3125L60.1715 56.0657L49.9717 71.1921L50.9596 55.3125Z",
    fill: "#DB9D77"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9714 71.1919L56.101 72.424C56.101 72.424 49.3763 81.7899 49.3205 81.6272C49.2647 81.4644 49.9691 71.1919 49.9691 71.1919H49.9714Z",
    fill: "#D1A389"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3916 71.6919L72.7373 77.7034L56.1011 72.4218L61.3916 71.6919Z",
    fill: "#DEB9A2"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1011 72.4219L58.5418 77.4222L72.7373 77.7034L56.1011 72.4219Z",
    fill: "#E9C3B7"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5418 77.4223C58.5418 77.4223 49.3764 81.4648 49.3207 81.6275C49.2649 81.7903 56.1011 72.4243 56.1011 72.4243L58.5418 77.4223Z",
    fill: "#DEB29C"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3916 71.6917L70.1433 71.1919L72.7374 77.7032L61.3916 71.6917Z",
    fill: "#E9B7A0"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1714 56.0654L69.6111 63.6902L61.3917 71.6916L60.1714 56.0654Z",
    fill: "#E7C2AF"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6111 63.6904V52.9575L60.1714 56.0656L69.6111 63.6904Z",
    fill: "#D8AA8F"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6108 52.9575L74.992 58.3228L69.6108 63.6904V52.9575Z",
    fill: "#E1B096"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2144 72.1849C68.6068 72.0198 64.9992 71.8548 61.3916 71.6897C64.6738 68.491 67.9559 65.2923 71.2381 62.0913C71.5635 65.4551 71.8889 68.8188 72.2144 72.1825V72.1849Z",
    fill: "#E9B7A1"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M74.992 58.3232L72.2352 71.1924L69.6108 63.6908L74.992 58.3232Z",
    fill: "#DEA891"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3502 58.7945L86.2773 56.0654L95.0011 66.324L94.3502 58.7945Z",
    fill: "#845243"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2773 56.0654L91.6515 69.8412L95.0011 66.324L86.2773 56.0654Z",
    fill: "#88604A"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M84.585 69.9063L86.2772 56.0654L91.6514 69.8412L84.585 69.9063Z",
    fill: "#B77D64"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5853 69.9069L74.9922 58.3232L79.3041 74.698L84.5853 69.9069Z",
    fill: "#D79D7D"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9922 58.3226L86.2775 56.0654L84.5853 69.9063L74.9922 58.3226Z",
    fill: "#D08F72"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3038 74.6974L72.7372 77.7032L70.1431 71.1919L79.3038 74.6974Z",
    fill: "#E6B49B"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9717 71.1918L60.1715 56.0654C60.9316 62.1978 61.6917 68.3325 62.4495 74.4649C58.291 73.3746 54.1302 72.2821 49.9717 71.1918Z",
    fill: "#E2AB8D"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1217 76.1528L75.9335 80.4743L72.7373 77.7034L76.1217 76.1528Z",
    fill: "#D6A28D"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7373 77.7036V81.3649L75.9335 80.4746L72.7373 77.7036Z",
    fill: "#AA7968"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1221 76.1533L77.6516 75.4536L77.619 77.7039L76.1221 76.1533Z",
    fill: "#B8846C"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6188 77.7034L75.9336 80.4743L76.1219 76.1528L77.6188 77.7034Z",
    fill: "#C8917B"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7913 80.4744L76.8401 78.9819L75.9336 80.4744H76.7913Z",
    fill: "#CB9680"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6514 75.4533L80.1386 75.8694L80.4826 73.6284L77.6514 75.4533Z",
    fill: "#D5A38D"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6512 75.4536L77.6187 77.7039L80.1384 75.8697L77.6512 75.4536Z",
    fill: "#C89883"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4824 73.6283L82.2281 71.9731L85.7288 76.0575L80.4824 73.6283Z",
    fill: "#DA9F84"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1387 75.8574L85.729 76.0574L80.4827 73.4863L80.1387 75.8574Z",
    fill: "#CF997F"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3977 106.691C91.963 108.644 91.5307 110.597 91.096 112.552L89.6362 111.413C90.5567 109.839 91.4772 108.265 92.4 106.691H92.3977Z",
    fill: "#4D3333"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0936 112.552L88.4902 117.676L89.6339 111.413L91.0936 112.552Z",
    fill: "#593C35"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4906 117.675L87.0518 111.957C88.0745 111.287 89.095 110.618 90.1177 109.948C89.5761 112.524 89.0322 115.1 88.4906 117.675Z",
    fill: "#7E4F49"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9088 114.165L71.3569 111.957L64.4834 117.504L64.9088 114.165Z",
    fill: "#DEAB9E"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8223 117.436C62.1844 116.346 63.5465 115.255 64.9087 114.167L64.4833 117.503C63.263 117.48 62.0426 117.459 60.8223 117.436Z",
    fill: "#C79889"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6011 115.402L79.0506 115.483L76.1218 112.403L75.6011 115.402Z",
    fill: "#E8B4A7"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6011 115.402L79.0506 115.483L77.0376 116.948L75.6011 115.402Z",
    fill: "#EAB2A6"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7505 111.901L83.3999 115.835L79.0508 115.484L79.7505 111.901Z",
    fill: "#C59080"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0508 115.483L85.4989 115.834L83.358 117.064L79.0508 115.483Z",
    fill: "#754E4F"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M85.236 115.809C84.9734 116.676 84.7107 117.545 84.448 118.413L82.3862 117.676C83.3346 117.053 84.2853 116.43 85.2337 115.807L85.236 115.809Z",
    fill: "#6D4741"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4834 117.504L74.9923 114.165L71.3569 111.957L64.4834 117.504Z",
    fill: "#F5CDBE"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4834 117.504L75.6014 115.402L74.9923 114.166L64.4834 117.504Z",
    fill: "#E8BDA7"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3999 115.834L87.9861 115.672C87.7211 114.523 87.4538 113.375 87.1888 112.227C85.9266 113.428 84.6621 114.633 83.3999 115.834Z",
    fill: "#7C5D53"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9277 115.823C85.4503 116.437 86.9728 117.048 88.4977 117.662C88.3838 116.932 88.2722 116.202 88.1583 115.47C86.7473 115.588 85.3387 115.705 83.9277 115.823Z",
    fill: "#73514F"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4906 117.676L82.9165 124.036L85.0736 116.176L88.4906 117.676Z",
    fill: "#966B69"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6304 124.273C83.9786 124.382 85.3268 124.489 86.675 124.598L88.4904 117.678C86.5378 119.877 84.5853 122.076 82.6304 124.273Z",
    fill: "#805952"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6092 122.606C82.6162 124.138 82.6232 125.67 82.6302 127.202C79.3317 126.732 76.0333 126.265 72.7349 125.795L82.6092 122.606Z",
    fill: "#916560"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4834 117.503L75.6014 115.402L68.528 117.596L64.4834 117.503Z",
    fill: "#A87669"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6094 124.036L82.6303 131.888L86.6749 124.598L82.6094 124.036Z",
    fill: "#8D6560"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3403 129.947L77.7489 126.335L69.7457 125.34L66.3403 129.947Z",
    fill: "#D7B4A7"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5215 131.598L64.0764 136.5L58.2978 130.907L52.5215 131.598Z",
    fill: "#AE8D88"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0765 136.5L66.3405 129.947L58.2979 130.907L64.0765 136.5Z",
    fill: "#B7958B"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0767 136.501L77.7492 126.335L66.3407 129.947L64.0767 136.501Z",
    fill: "#CCAA9A"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M77.749 126.335L82.6304 131.889V126.388L77.749 126.335Z",
    fill: "#AA7768"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4082 129.362L68.6348 133.114L77.749 126.335L80.4082 129.362Z",
    fill: "#CD9E8E"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6348 133.113L80.4082 133.49V129.361L68.6348 133.113Z",
    fill: "#AB7E6B"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0767 136.5L80.4084 133.49L68.635 133.113L64.0767 136.5Z",
    fill: "#B48A7E"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4082 133.49L82.6304 131.888L80.4082 129.361V133.49Z",
    fill: "#785A55"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4084 133.49L74.1672 136.973L64.0767 136.501L80.4084 133.49Z",
    fill: "#9B7A79"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3981 136.889L65.7036 143.656L67.3447 148.551L72.3981 136.889Z",
    fill: "#875F55"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7035 143.656L59.1113 156.081L67.3446 148.551L65.7035 143.656Z",
    fill: "#A37E72"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3981 136.889L71.2615 148.033L67.3447 148.551L72.3981 136.889Z",
    fill: "#474137"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1113 156.081L68.6347 153.728L67.3446 148.551L59.1113 156.081Z",
    fill: "#B38F7D"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1113 156.081L64.0764 157.587L64.9086 154.649L59.1113 156.081Z",
    fill: "#C4977D"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1113 156.081C60.6292 156.541 62.1448 157.002 63.6626 157.462L59.1113 156.081Z",
    fill: "#CAAF93"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1011 134.873L59.1113 156.081L65.7035 143.656L56.1011 134.873Z",
    fill: "#C79885"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M32.452 97.0303L29.8579 110.144L32.989 113.04L32.452 97.0303Z",
    fill: "#937D70"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8579 110.144L30.188 116.176L32.989 113.04L29.8579 110.144Z",
    fill: "#A48C81"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3457 115.997L36.2592 130.908L32.182 113.942L30.3457 115.997Z",
    fill: "#B99980"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1826 113.942L32.9892 113.04L44.0584 125.737L32.1826 113.942Z",
    fill: "#B4978C"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2597 130.908L44.0584 125.738L32.1826 113.942L36.2597 130.908Z",
    fill: "#CFA998"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2593 130.907L56.101 134.873L40.7013 127.962L36.2593 130.907Z",
    fill: "#DEB3A8"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2593 130.907L40.1504 140.062L56.101 134.873L36.2593 130.907Z",
    fill: "#DBB1A4"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1504 140.062L45.0341 141.038L56.1009 134.873L40.1504 140.062Z",
    fill: "#D1A999"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0347 141.038L47.6381 146.571L56.1015 134.873L45.0347 141.038Z",
    fill: "#CDA395"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6382 146.571V151.092L56.1016 134.873L47.6382 146.571Z",
    fill: "#E1B29A"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6382 151.092L53.4982 158.617L56.1016 134.873L47.6382 151.092Z",
    fill: "#DAAC8F"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M53.498 158.617L54.4743 170.426L56.1015 134.873L53.498 158.617Z",
    fill: "#F0C0AD"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4741 170.426H56.7312L56.1013 134.873L54.4741 170.426Z",
    fill: "#EABFAE"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7314 170.426L57.4032 169.45L56.7314 160.223V170.426Z",
    fill: "#C4B7A8"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5892 170.589C57.4307 168.388 58.2721 158.282 59.1113 156.081L56.1011 134.871C56.2638 144.142 56.4265 161.318 56.5892 170.589Z",
    fill: "#E8B99F"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7414 140.062L37.8726 140.387V145.02L39.7414 140.062Z",
    fill: "#D5E4E3"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7334 145.106C40.3131 147.059 43.8951 149.012 47.4748 150.967C44.9783 146.734 42.4841 142.503 39.9877 138.27C38.9021 140.548 37.8166 142.828 36.7334 145.106Z",
    fill: "#FBFDF7"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1504 140.062L40.9407 145.476L45.0341 141.038L40.1504 140.062Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7314 170.426L65.5412 171.405L63.663 157.462L56.7314 170.426Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M68.635 153.729L64.0767 157.587L64.9088 154.649L68.635 153.729Z",
    fill: "#DFCEBC"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9599 157.478C69.7269 154.33 70.494 151.18 71.2611 148.033L67.2979 148.412C67.8511 151.434 68.4066 154.456 68.9599 157.475V157.478Z",
    fill: "#BDBEBC"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3496 147.175L80.4081 143.656L74.1669 136.973L71.3496 147.175Z",
    fill: "#644941"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3979 136.889L74.1669 136.972L71.3496 147.175L72.3979 136.889Z",
    fill: "#433937"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M74.167 136.973L78.888 136.805L80.4082 143.656L74.167 136.973Z",
    fill: "#5F3B32"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M78.888 136.805L80.4082 133.49L74.167 136.973L78.888 136.805Z",
    fill: "#785353"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4079 143.656V133.49L78.8877 136.805L80.4079 143.656Z",
    fill: "#3D3835"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2617 143.712L82.4676 143.967L80.4082 133.49L80.2617 143.712Z",
    fill: "#443833"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M80.587 143.711L68.96 153.726C69.7201 151.504 70.4802 149.281 71.2379 147.059C74.3551 145.943 77.4699 144.827 80.587 143.711Z",
    fill: "#F7F9FA"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5408 171.405L80.4081 143.656L63.6626 157.462L65.5408 171.405Z",
    fill: "#D2D7D6"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4084 143.656V157.975L65.541 171.405L80.4084 143.656Z",
    fill: "#E8E9E9"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2617 143.711L82.4676 143.967L80.4082 157.975L80.2617 143.711Z",
    fill: "#FAFDFD"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4676 143.967L82.7931 155.037L80.8149 155.209L82.4676 143.967Z",
    fill: "#FEF7F7"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M65.541 171.405L72.7585 171.235C76.1569 168.96 79.5576 158.778 82.956 156.502C77.1518 158.836 71.3452 169.071 65.541 171.405Z",
    fill: "#E0E7E5"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4678 143.967L87.57 157.587L82.7932 155.037L82.4678 143.967Z",
    fill: "#F9B7B1"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3645 149.033L89.5458 146.571L82.4678 143.967L84.3645 149.033Z",
    fill: "#8C5D51"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9956 141.561L89.5455 146.571L82.4675 143.967L81.9956 141.561Z",
    fill: "#88453B"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3643 149.033L103.627 156.664L89.5455 146.571L84.3643 149.033Z",
    fill: "#DDB7B5"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3643 149.032L99.0689 156.989L87.5697 157.587L84.3643 149.032Z",
    fill: "#FFFEF9"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0689 156.989L103.627 156.664L84.3643 149.032L99.0689 156.989Z",
    fill: "#F3E0E3"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0693 164.894L112.416 171.08L103.628 164.568L99.0693 164.894Z",
    fill: "#F2B8BC"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5698 165.49L112.416 171.079L99.069 164.893L87.5698 165.49Z",
    fill: "#E2EEF3"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1885 157.478C88.9969 159.428 90.8077 169.285 92.6161 171.235L112.416 163.176C105.58 161.632 97.3952 159.784 87.1885 157.478Z",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7931 155.037L80.4059 157.978C80.3873 157.053 80.3687 156.127 80.3501 155.2C81.1637 155.146 81.9772 155.091 82.7908 155.037H82.7931Z",
    fill: "#E8E2D7"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7931 155.037L86.0079 159.919L80.4082 157.975L82.7931 155.037Z",
    fill: "#767D79"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4081 157.976L83.3695 171.235H72.7583L80.4081 157.976Z",
    fill: "#787775"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3696 171.235L86.0079 159.919L80.4082 157.976L83.3696 171.235Z",
    fill: "#A1ABAA"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0077 159.919L87.5698 157.587L82.793 155.037L86.0077 159.919Z",
    fill: "#BDC3BD"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7085 145.42L53.3374 158.412L47.6378 151.092L40.7085 145.42Z",
    fill: "#F8F8FB"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7085 145.42L43.7652 151.092L51.7451 156.773L40.7085 145.42Z",
    fill: "#C9DADA"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7651 151.092L52.0589 171.405L51.7451 156.774L43.7651 151.092Z",
    fill: "#FFFDFE"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0589 171.405L53.4978 158.617L51.7451 156.773L52.0589 171.405Z",
    fill: "#FAFCFC"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0591 171.405L54.4742 170.426L53.4979 158.617L52.0591 171.405Z",
    fill: "#FAFDFE"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M39.012 139.899C33.1613 140.78 27.3082 141.661 21.4575 142.543L30.0604 143.644C33.045 142.396 36.0273 141.148 39.012 139.902V139.899Z",
    fill: "#4D616B"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0601 143.641L37.8726 145.02V140.387L30.0601 143.641Z",
    fill: "#667884"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0601 143.642L43.7652 151.092L40.7085 145.42L30.0601 143.642Z",
    fill: "#70818E"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0602 143.642L29.9277 148.551L43.7653 151.092L30.0602 143.642Z",
    fill: "#607180"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6177 143.202L29.9277 148.551L30.0602 143.642L26.6177 143.202Z",
    fill: "#617C8C"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9273 148.551L38.5395 171.235L52.0587 171.405C52.0587 171.405 29.7949 148.577 29.9273 148.551Z",
    fill: "#5F778A"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2232 107.996C29.3724 107.773 28.5217 107.549 27.6709 107.329L30.3487 115.999C30.3069 113.333 30.265 110.664 30.2232 107.998V107.996Z",
    fill: "#BFB9B8"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6685 107.326L13.6914 125.737L30.3463 115.997L27.6685 107.326Z",
    fill: "#DDDDD3"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6914 125.737L40.7018 139.883L30.3463 115.997L13.6914 125.737Z",
    fill: "white"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6914 125.737L7.97314 141.561L40.7017 139.883L13.6914 125.737Z",
    fill: "white"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97314 141.561L21.4574 142.54L40.7017 139.883L7.97314 141.561Z",
    fill: "#838A89"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9372 110.925L16.7132 112.389L13.6914 125.737L24.9372 110.925Z",
    fill: "#DAEAF3"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M0 112.536V119.349L13.6912 125.737L16.713 112.389L0 112.536Z",
    fill: "white"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M0 119.349V131.233L7.97295 141.561L13.6912 125.737L0 119.349Z",
    fill: "#EEF8FC"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M0 131.04V138.837L7.97295 141.561L0 131.04Z",
    fill: "#CDE3F1"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97314 141.561L38.54 171.235L21.4574 142.54L7.97314 141.561Z",
    fill: "white"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4575 142.54L26.6179 143.202L38.5401 171.235L21.4575 142.54Z",
    fill: "#E9F2F4"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M0 171.363L38.5398 171.235L7.97295 141.561L0 153.556V171.363Z",
    fill: "#F7F7F8"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M0 138.837V153.556L7.97295 141.561L0 138.837Z",
    fill: "white"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9641 99.4946L30.3463 101.81L26.8921 101.466L31.9641 99.4946Z",
    fill: "#C78C80"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8916 101.466L22.0195 96.5562L31.9636 99.4945L26.8916 101.466Z",
    fill: "#EFBCA6"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6689 96.4259C24.1956 94.966 26.72 93.5038 29.2467 92.0439C30.1533 94.5267 31.0598 97.0117 31.9664 99.4944L21.6713 96.4282L21.6689 96.4259Z",
    fill: "#EBB095"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4853 86.0113L23.5049 72.9492L31.8335 83.4287L30.4853 86.0113Z",
    fill: "#DFB095"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5049 72.9492L26.3989 73.628C29.409 78.791 32.4192 83.9517 35.4318 89.1147C31.4569 83.7262 27.4797 78.3377 23.5049 72.9515V72.9492Z",
    fill: "#A27D6B"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5051 72.9492L21.3154 73.4862L26.0829 77.7705L23.5051 72.9492Z",
    fill: "#C08673"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3153 73.4863L19.314 75.453L26.0828 77.7706L21.3153 73.4863Z",
    fill: "#B87B60"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3139 75.4536L17.5752 81.1699L18.7746 86.6328L19.3139 75.4536Z",
    fill: "#BE987F"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0831 77.7713L18.7749 86.6328L19.3142 75.4536L26.0831 77.7713Z",
    fill: "#CD8D6F"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7748 86.6322L21.6688 96.4259C21.6688 96.4259 28.9327 92.3392 29.0071 92.4345C28.9955 92.4554 26.3131 90.9398 18.7725 86.6299L18.7748 86.6322Z",
    fill: "#F0BCA3"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0831 77.771L23.9445 89.5848L18.7749 86.6325L26.0831 77.771Z",
    fill: "#E4B092"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9443 89.5845L28.491 82.2759L29.007 92.4345L23.9443 89.5845Z",
    fill: "#FBCFBD"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0829 77.771L28.491 82.2761L23.9443 89.5848L26.0829 77.771Z",
    fill: "#DFA987"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4907 82.2759L29.0068 92.4345L31.8333 83.4289L28.4907 82.2759Z",
    fill: "#D5A08B"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7593 52.6533L32.9888 58.6764L34.7298 86.1931L21.7593 52.6533Z",
    fill: "#333534"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2896 57.7629L33.6396 50.5356L40.7292 63.6907L31.2896 57.7629Z",
    fill: "#444D4D"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7593 52.6533L24.2 43.7012L31.2896 57.7629L21.7593 52.6533Z",
    fill: "#2B2B2E"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2002 43.7012L28.7585 44.6775L27.3057 49.8591L24.2002 43.7012Z",
    fill: "#3A3E41"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7586 44.6777L31.2899 57.7654C29.8488 55.1944 28.4076 52.621 26.9688 50.05C27.5661 48.26 28.1612 46.47 28.7586 44.6777Z",
    fill: "#25292A"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7583 44.6777L33.642 50.5381C32.8285 53.0883 32.0149 55.6384 31.2013 58.1885C30.3878 53.6857 29.5742 49.1829 28.7606 44.6777H28.7583Z",
    fill: "#2A2F2F"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6396 50.5357L53.9323 50.0405L40.7293 63.6908L33.6396 50.5357Z",
    fill: "#2F3134"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9323 50.0406L28.4746 44.6172L33.6396 50.5357L53.9323 50.0406Z",
    fill: "#2C3334"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2002 43.701L27.7822 32.9565L34.5069 45.9024L24.2002 43.701Z",
    fill: "#2F3033"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5068 45.9022L42.2659 29.4717L45.132 48.1641L34.5068 45.9022Z",
    fill: "#353A3C"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7822 32.9563L42.266 29.4717L34.5069 45.9022L27.7822 32.9563Z",
    fill: "#2D2F30"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7822 32.9568L33.6399 27.1196L42.266 29.4722L27.7822 32.9568Z",
    fill: "#272D2A"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2661 29.4717L50.5668 36.864L45.1322 48.1641L42.2661 29.4717Z",
    fill: "#414545"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5665 36.8643L53.9323 50.0403L45.1318 48.1643L50.5665 36.8643Z",
    fill: "#3B3B3D"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6396 27.1197L45.1319 19.918L42.2658 29.4722L33.6396 27.1197Z",
    fill: "#2C3635"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1322 19.6367L50.5668 36.8646L42.2661 29.4722L45.1322 19.6367Z",
    fill: "#2A2C2F"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1318 19.6366L53.4976 17.9814L50.5665 36.8644L45.1318 19.6366Z",
    fill: "#35383A"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5664 36.8643L68.6857 50.5354L53.9322 50.0403L50.5664 36.8643Z",
    fill: "#282B2B"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5664 36.8643L62.4259 24.6948L69.6108 43.1687L50.5664 36.8643Z",
    fill: "#2E2B2F"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6108 43.1687L68.6857 50.5354L50.5664 36.8643L69.6108 43.1687Z",
    fill: "#2F2F31"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M53.498 17.9814H67.2729L62.4264 24.695L53.498 17.9814Z",
    fill: "#1F3B3E"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2728 17.9814L74.4299 20.7501L62.4263 24.695L67.2728 17.9814Z",
    fill: "#233E44"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4297 20.75C74.4297 20.75 82.9256 25.8595 82.5351 25.9897C82.1446 26.1199 76.61 25.9897 76.61 25.9897L74.4297 20.75Z",
    fill: "#63463D"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4298 20.7499L76.6101 25.9896C71.5637 25.6525 66.5196 25.3178 61.4731 24.9807C65.792 23.5697 70.1109 22.1586 74.4298 20.7476V20.7499Z",
    fill: "#38393A"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5326 25.9897L89.2969 33.933L76.6099 25.9897H82.5326Z",
    fill: "#563A33"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7727 25.9571C74.2762 31.6943 71.782 37.4315 69.2855 43.1687L62.1006 24.6948C66.9913 25.1156 71.882 25.5363 76.7727 25.9571Z",
    fill: "#26312F"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2969 33.9326L92.0095 35.167V42.5105L89.2969 33.9326Z",
    fill: "#3F282A"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0098 35.1674C93.6578 39.6934 95.3059 44.2195 96.9539 48.7455C95.3059 46.6673 93.6578 44.5891 92.0098 42.5086V35.165V35.1674Z",
    fill: "#61232C"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0095 42.5105L69.6108 43.1684L89.2968 33.9326L92.0095 42.5105Z",
    fill: "#2F2A2F"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6289 48.0947C97.8771 50.3194 99.1254 52.5441 100.371 54.7687C99.1324 61.4149 97.9539 67.696 97.9236 67.6914C97.9213 67.6914 97.9283 67.6379 97.9306 67.6286C98.012 67.0475 97.6772 61.6357 96.6289 48.0971V48.0947Z",
    fill: "#8A3C33"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0098 42.5112L93.2975 52.9581L96.9981 48.6715L92.0098 42.5112Z",
    fill: "#772F30"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6108 43.1691L93.2972 52.9581L92.0095 42.5112L69.6108 43.1691Z",
    fill: "#2F2C2E"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6112 43.1689L68.686 50.5357L93.2976 52.958L69.6112 43.1689Z",
    fill: "#2D2928"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2778 56.0658L93.2977 52.9577L72.7842 50.9399L86.2778 56.0658Z",
    fill: "#3B3133"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8325 55.3124L60.1713 56.0656L69.611 52.9575L48.8325 55.3124Z",
    fill: "#92654A"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8501 82.9291C32.0128 86.4021 32.1755 89.8751 32.3359 93.3458L34.7789 86.1929C33.8027 85.1049 32.8264 84.017 31.8501 82.9268V82.9291Z",
    fill: "#C59581"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M32.329 93.3458C35.2067 96.2748 38.0867 99.2062 40.9644 102.135C38.8863 96.8211 36.8082 91.507 34.7278 86.1929L32.3267 93.3458H32.329Z",
    fill: "#C3927B"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0073 92.4347L31.8339 83.4268C32.164 89.4452 32.4964 95.4637 32.8264 101.482C31.5526 98.4671 30.2811 95.4498 29.0073 92.4347Z",
    fill: "#DBA586"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4976 17.9814L62.4259 24.695L50.5664 36.8644L53.4976 17.9814Z",
    fill: "#243131"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1117 156.081L56.7314 170.426L63.663 157.462L59.1117 156.081Z",
    fill: "#CAAF93"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M191.724 116.012H188.58L188.076 117.5H185.928L188.976 109.076H191.352L194.4 117.5H192.228L191.724 116.012ZM191.196 114.428L190.152 111.344L189.12 114.428H191.196ZM194.98 113.276C194.98 112.444 195.16 111.704 195.52 111.056C195.88 110.4 196.38 109.892 197.02 109.532C197.668 109.164 198.4 108.98 199.216 108.98C200.216 108.98 201.072 109.244 201.784 109.772C202.496 110.3 202.972 111.02 203.212 111.932H200.956C200.788 111.58 200.548 111.312 200.236 111.128C199.932 110.944 199.584 110.852 199.192 110.852C198.56 110.852 198.048 111.072 197.656 111.512C197.264 111.952 197.068 112.54 197.068 113.276C197.068 114.012 197.264 114.6 197.656 115.04C198.048 115.48 198.56 115.7 199.192 115.7C199.584 115.7 199.932 115.608 200.236 115.424C200.548 115.24 200.788 114.972 200.956 114.62H203.212C202.972 115.532 202.496 116.252 201.784 116.78C201.072 117.3 200.216 117.56 199.216 117.56C198.4 117.56 197.668 117.38 197.02 117.02C196.38 116.652 195.88 116.144 195.52 115.496C195.16 114.848 194.98 114.108 194.98 113.276ZM210.529 109.076V110.72H208.297V117.5H206.245V110.72H204.013V109.076H210.529ZM215.542 117.584C214.75 117.584 214.022 117.4 213.358 117.032C212.702 116.664 212.178 116.152 211.786 115.496C211.402 114.832 211.21 114.088 211.21 113.264C211.21 112.44 211.402 111.7 211.786 111.044C212.178 110.388 212.702 109.876 213.358 109.508C214.022 109.14 214.75 108.956 215.542 108.956C216.334 108.956 217.058 109.14 217.714 109.508C218.378 109.876 218.898 110.388 219.274 111.044C219.658 111.7 219.85 112.44 219.85 113.264C219.85 114.088 219.658 114.832 219.274 115.496C218.89 116.152 218.37 116.664 217.714 117.032C217.058 117.4 216.334 117.584 215.542 117.584ZM215.542 115.712C216.214 115.712 216.75 115.488 217.15 115.04C217.558 114.592 217.762 114 217.762 113.264C217.762 112.52 217.558 111.928 217.15 111.488C216.75 111.04 216.214 110.816 215.542 110.816C214.862 110.816 214.318 111.036 213.91 111.476C213.51 111.916 213.31 112.512 213.31 113.264C213.31 114.008 213.51 114.604 213.91 115.052C214.318 115.492 214.862 115.712 215.542 115.712ZM225.288 117.5L223.536 114.32H223.044V117.5H220.992V109.076H224.436C225.1 109.076 225.664 109.192 226.128 109.424C226.6 109.656 226.952 109.976 227.184 110.384C227.416 110.784 227.532 111.232 227.532 111.728C227.532 112.288 227.372 112.788 227.052 113.228C226.74 113.668 226.276 113.98 225.66 114.164L227.604 117.5H225.288ZM223.044 112.868H224.316C224.692 112.868 224.972 112.776 225.156 112.592C225.348 112.408 225.444 112.148 225.444 111.812C225.444 111.492 225.348 111.24 225.156 111.056C224.972 110.872 224.692 110.78 224.316 110.78H223.044V112.868ZM233.571 115.604L232.239 119.048H230.931L231.627 115.604H233.571ZM240.399 117.584C239.783 117.584 239.231 117.484 238.743 117.284C238.255 117.084 237.863 116.788 237.567 116.396C237.279 116.004 237.127 115.532 237.111 114.98H239.295C239.327 115.292 239.435 115.532 239.619 115.7C239.803 115.86 240.043 115.94 240.339 115.94C240.643 115.94 240.883 115.872 241.059 115.736C241.235 115.592 241.323 115.396 241.323 115.148C241.323 114.94 241.251 114.768 241.107 114.632C240.971 114.496 240.799 114.384 240.591 114.296C240.391 114.208 240.103 114.108 239.727 113.996C239.183 113.828 238.739 113.66 238.395 113.492C238.051 113.324 237.755 113.076 237.507 112.748C237.259 112.42 237.135 111.992 237.135 111.464C237.135 110.68 237.419 110.068 237.987 109.628C238.555 109.18 239.295 108.956 240.207 108.956C241.135 108.956 241.883 109.18 242.451 109.628C243.019 110.068 243.323 110.684 243.363 111.476H241.143C241.127 111.204 241.027 110.992 240.843 110.84C240.659 110.68 240.423 110.6 240.135 110.6C239.887 110.6 239.687 110.668 239.535 110.804C239.383 110.932 239.307 111.12 239.307 111.368C239.307 111.64 239.435 111.852 239.691 112.004C239.947 112.156 240.347 112.32 240.891 112.496C241.435 112.68 241.875 112.856 242.211 113.024C242.555 113.192 242.851 113.436 243.099 113.756C243.347 114.076 243.471 114.488 243.471 114.992C243.471 115.472 243.347 115.908 243.099 116.3C242.859 116.692 242.507 117.004 242.043 117.236C241.579 117.468 241.031 117.584 240.399 117.584ZM246.786 109.076V117.5H244.734V109.076H246.786ZM255.809 117.5H253.757L250.325 112.304V117.5H248.273V109.076H250.325L253.757 114.296V109.076H255.809V117.5ZM262.889 111.74C262.737 111.46 262.517 111.248 262.229 111.104C261.949 110.952 261.617 110.876 261.233 110.876C260.569 110.876 260.037 111.096 259.637 111.536C259.237 111.968 259.037 112.548 259.037 113.276C259.037 114.052 259.245 114.66 259.661 115.1C260.085 115.532 260.665 115.748 261.401 115.748C261.905 115.748 262.329 115.62 262.673 115.364C263.025 115.108 263.281 114.74 263.441 114.26H260.837V112.748H265.301V114.656C265.149 115.168 264.889 115.644 264.521 116.084C264.161 116.524 263.701 116.88 263.141 117.152C262.581 117.424 261.949 117.56 261.245 117.56C260.413 117.56 259.669 117.38 259.013 117.02C258.365 116.652 257.857 116.144 257.489 115.496C257.129 114.848 256.949 114.108 256.949 113.276C256.949 112.444 257.129 111.704 257.489 111.056C257.857 110.4 258.365 109.892 259.013 109.532C259.661 109.164 260.401 108.98 261.233 108.98C262.241 108.98 263.089 109.224 263.777 109.712C264.473 110.2 264.933 110.876 265.157 111.74H262.889ZM268.489 110.72V112.424H271.237V114.008H268.489V115.856H271.597V117.5H266.437V109.076H271.597V110.72H268.489ZM277.226 117.5L275.474 114.32H274.982V117.5H272.93V109.076H276.374C277.038 109.076 277.602 109.192 278.066 109.424C278.538 109.656 278.89 109.976 279.122 110.384C279.354 110.784 279.47 111.232 279.47 111.728C279.47 112.288 279.31 112.788 278.99 113.228C278.678 113.668 278.214 113.98 277.598 114.164L279.542 117.5H277.226ZM274.982 112.868H276.254C276.63 112.868 276.91 112.776 277.094 112.592C277.286 112.408 277.382 112.148 277.382 111.812C277.382 111.492 277.286 111.24 277.094 111.056C276.91 110.872 276.63 110.78 276.254 110.78H274.982V112.868ZM285.509 115.604L284.177 119.048H282.869L283.565 115.604H285.509ZM286.398 113.276C286.398 112.444 286.578 111.704 286.938 111.056C287.298 110.4 287.798 109.892 288.438 109.532C289.086 109.164 289.818 108.98 290.634 108.98C291.634 108.98 292.49 109.244 293.202 109.772C293.914 110.3 294.39 111.02 294.63 111.932H292.374C292.206 111.58 291.966 111.312 291.654 111.128C291.35 110.944 291.002 110.852 290.61 110.852C289.978 110.852 289.466 111.072 289.074 111.512C288.682 111.952 288.486 112.54 288.486 113.276C288.486 114.012 288.682 114.6 289.074 115.04C289.466 115.48 289.978 115.7 290.61 115.7C291.002 115.7 291.35 115.608 291.654 115.424C291.966 115.24 292.206 114.972 292.374 114.62H294.63C294.39 115.532 293.914 116.252 293.202 116.78C292.49 117.3 291.634 117.56 290.634 117.56C289.818 117.56 289.086 117.38 288.438 117.02C287.798 116.652 287.298 116.144 286.938 115.496C286.578 114.848 286.398 114.108 286.398 113.276ZM299.871 117.584C299.079 117.584 298.351 117.4 297.687 117.032C297.031 116.664 296.507 116.152 296.115 115.496C295.731 114.832 295.539 114.088 295.539 113.264C295.539 112.44 295.731 111.7 296.115 111.044C296.507 110.388 297.031 109.876 297.687 109.508C298.351 109.14 299.079 108.956 299.871 108.956C300.663 108.956 301.387 109.14 302.043 109.508C302.707 109.876 303.227 110.388 303.603 111.044C303.987 111.7 304.179 112.44 304.179 113.264C304.179 114.088 303.987 114.832 303.603 115.496C303.219 116.152 302.699 116.664 302.043 117.032C301.387 117.4 300.663 117.584 299.871 117.584ZM299.871 115.712C300.543 115.712 301.079 115.488 301.479 115.04C301.887 114.592 302.091 114 302.091 113.264C302.091 112.52 301.887 111.928 301.479 111.488C301.079 111.04 300.543 110.816 299.871 110.816C299.191 110.816 298.647 111.036 298.239 111.476C297.839 111.916 297.639 112.512 297.639 113.264C297.639 114.008 297.839 114.604 298.239 115.052C298.647 115.492 299.191 115.712 299.871 115.712ZM312.856 117.5H310.804L307.372 112.304V117.5H305.32V109.076H307.372L310.804 114.296V109.076H312.856V117.5ZM317.5 109.076C318.388 109.076 319.164 109.252 319.828 109.604C320.492 109.956 321.004 110.452 321.364 111.092C321.732 111.724 321.916 112.456 321.916 113.288C321.916 114.112 321.732 114.844 321.364 115.484C321.004 116.124 320.488 116.62 319.816 116.972C319.152 117.324 318.38 117.5 317.5 117.5H314.344V109.076H317.5ZM317.368 115.724C318.144 115.724 318.748 115.512 319.18 115.088C319.612 114.664 319.828 114.064 319.828 113.288C319.828 112.512 319.612 111.908 319.18 111.476C318.748 111.044 318.144 110.828 317.368 110.828H316.396V115.724H317.368ZM325.078 109.076V114.116C325.078 114.62 325.202 115.008 325.45 115.28C325.698 115.552 326.062 115.688 326.542 115.688C327.022 115.688 327.39 115.552 327.646 115.28C327.902 115.008 328.03 114.62 328.03 114.116V109.076H330.082V114.104C330.082 114.856 329.922 115.492 329.602 116.012C329.282 116.532 328.85 116.924 328.306 117.188C327.77 117.452 327.17 117.584 326.506 117.584C325.842 117.584 325.246 117.456 324.718 117.2C324.198 116.936 323.786 116.544 323.482 116.024C323.178 115.496 323.026 114.856 323.026 114.104V109.076H325.078ZM331.175 113.276C331.175 112.444 331.355 111.704 331.715 111.056C332.075 110.4 332.575 109.892 333.215 109.532C333.863 109.164 334.595 108.98 335.411 108.98C336.411 108.98 337.267 109.244 337.979 109.772C338.691 110.3 339.167 111.02 339.407 111.932H337.151C336.983 111.58 336.743 111.312 336.431 111.128C336.127 110.944 335.779 110.852 335.387 110.852C334.755 110.852 334.243 111.072 333.851 111.512C333.459 111.952 333.263 112.54 333.263 113.276C333.263 114.012 333.459 114.6 333.851 115.04C334.243 115.48 334.755 115.7 335.387 115.7C335.779 115.7 336.127 115.608 336.431 115.424C336.743 115.24 336.983 114.972 337.151 114.62H339.407C339.167 115.532 338.691 116.252 337.979 116.78C337.267 117.3 336.411 117.56 335.411 117.56C334.595 117.56 333.863 117.38 333.215 117.02C332.575 116.652 332.075 116.144 331.715 115.496C331.355 114.848 331.175 114.108 331.175 113.276ZM346.724 109.076V110.72H344.492V117.5H342.44V110.72H340.208V109.076H346.724ZM351.738 117.584C350.946 117.584 350.218 117.4 349.554 117.032C348.898 116.664 348.374 116.152 347.982 115.496C347.598 114.832 347.406 114.088 347.406 113.264C347.406 112.44 347.598 111.7 347.982 111.044C348.374 110.388 348.898 109.876 349.554 109.508C350.218 109.14 350.946 108.956 351.738 108.956C352.53 108.956 353.254 109.14 353.91 109.508C354.574 109.876 355.094 110.388 355.47 111.044C355.854 111.7 356.046 112.44 356.046 113.264C356.046 114.088 355.854 114.832 355.47 115.496C355.086 116.152 354.566 116.664 353.91 117.032C353.254 117.4 352.53 117.584 351.738 117.584ZM351.738 115.712C352.41 115.712 352.946 115.488 353.346 115.04C353.754 114.592 353.958 114 353.958 113.264C353.958 112.52 353.754 111.928 353.346 111.488C352.946 111.04 352.41 110.816 351.738 110.816C351.058 110.816 350.514 111.036 350.106 111.476C349.706 111.916 349.506 112.512 349.506 113.264C349.506 114.008 349.706 114.604 350.106 115.052C350.514 115.492 351.058 115.712 351.738 115.712ZM361.483 117.5L359.731 114.32H359.239V117.5H357.187V109.076H360.631C361.295 109.076 361.859 109.192 362.323 109.424C362.795 109.656 363.147 109.976 363.379 110.384C363.611 110.784 363.727 111.232 363.727 111.728C363.727 112.288 363.567 112.788 363.247 113.228C362.935 113.668 362.471 113.98 361.855 114.164L363.799 117.5H361.483ZM359.239 112.868H360.511C360.887 112.868 361.167 112.776 361.351 112.592C361.543 112.408 361.639 112.148 361.639 111.812C361.639 111.492 361.543 111.24 361.351 111.056C361.167 110.872 360.887 110.78 360.511 110.78H359.239V112.868ZM369.766 115.604L368.434 119.048H367.126L367.822 115.604H369.766ZM378.647 113.18C379.135 113.284 379.527 113.528 379.823 113.912C380.119 114.288 380.267 114.72 380.267 115.208C380.267 115.912 380.019 116.472 379.523 116.888C379.035 117.296 378.351 117.5 377.471 117.5H373.547V109.076H377.339C378.195 109.076 378.863 109.272 379.343 109.664C379.831 110.056 380.075 110.588 380.075 111.26C380.075 111.756 379.943 112.168 379.679 112.496C379.423 112.824 379.079 113.052 378.647 113.18ZM375.599 112.484H376.943C377.279 112.484 377.535 112.412 377.711 112.268C377.895 112.116 377.987 111.896 377.987 111.608C377.987 111.32 377.895 111.1 377.711 110.948C377.535 110.796 377.279 110.72 376.943 110.72H375.599V112.484ZM377.111 115.844C377.455 115.844 377.719 115.768 377.903 115.616C378.095 115.456 378.191 115.228 378.191 114.932C378.191 114.636 378.091 114.404 377.891 114.236C377.699 114.068 377.431 113.984 377.087 113.984H375.599V115.844H377.111ZM383.473 109.076V114.116C383.473 114.62 383.597 115.008 383.845 115.28C384.093 115.552 384.457 115.688 384.937 115.688C385.417 115.688 385.785 115.552 386.041 115.28C386.297 115.008 386.425 114.62 386.425 114.116V109.076H388.477V114.104C388.477 114.856 388.317 115.492 387.997 116.012C387.677 116.532 387.245 116.924 386.701 117.188C386.165 117.452 385.565 117.584 384.901 117.584C384.237 117.584 383.641 117.456 383.113 117.2C382.593 116.936 382.181 116.544 381.877 116.024C381.573 115.496 381.421 114.856 381.421 114.104V109.076H383.473ZM392.966 117.584C392.35 117.584 391.798 117.484 391.31 117.284C390.822 117.084 390.43 116.788 390.134 116.396C389.846 116.004 389.694 115.532 389.678 114.98H391.862C391.894 115.292 392.002 115.532 392.186 115.7C392.37 115.86 392.61 115.94 392.906 115.94C393.21 115.94 393.45 115.872 393.626 115.736C393.802 115.592 393.89 115.396 393.89 115.148C393.89 114.94 393.818 114.768 393.674 114.632C393.538 114.496 393.366 114.384 393.158 114.296C392.958 114.208 392.67 114.108 392.294 113.996C391.75 113.828 391.306 113.66 390.962 113.492C390.618 113.324 390.322 113.076 390.074 112.748C389.826 112.42 389.702 111.992 389.702 111.464C389.702 110.68 389.986 110.068 390.554 109.628C391.122 109.18 391.862 108.956 392.774 108.956C393.702 108.956 394.45 109.18 395.018 109.628C395.586 110.068 395.89 110.684 395.93 111.476H393.71C393.694 111.204 393.594 110.992 393.41 110.84C393.226 110.68 392.99 110.6 392.702 110.6C392.454 110.6 392.254 110.668 392.102 110.804C391.95 110.932 391.874 111.12 391.874 111.368C391.874 111.64 392.002 111.852 392.258 112.004C392.514 112.156 392.914 112.32 393.458 112.496C394.002 112.68 394.442 112.856 394.778 113.024C395.122 113.192 395.418 113.436 395.666 113.756C395.914 114.076 396.038 114.488 396.038 114.992C396.038 115.472 395.914 115.908 395.666 116.3C395.426 116.692 395.074 117.004 394.61 117.236C394.146 117.468 393.598 117.584 392.966 117.584ZM399.353 109.076V117.5H397.301V109.076H399.353ZM408.376 117.5H406.324L402.892 112.304V117.5H400.84V109.076H402.892L406.324 114.296V109.076H408.376V117.5ZM411.915 110.72V112.424H414.663V114.008H411.915V115.856H415.023V117.5H409.863V109.076H415.023V110.72H411.915ZM419.403 117.584C418.787 117.584 418.235 117.484 417.747 117.284C417.259 117.084 416.867 116.788 416.571 116.396C416.283 116.004 416.131 115.532 416.115 114.98H418.299C418.331 115.292 418.439 115.532 418.623 115.7C418.807 115.86 419.047 115.94 419.343 115.94C419.647 115.94 419.887 115.872 420.063 115.736C420.239 115.592 420.327 115.396 420.327 115.148C420.327 114.94 420.255 114.768 420.111 114.632C419.975 114.496 419.803 114.384 419.595 114.296C419.395 114.208 419.107 114.108 418.731 113.996C418.187 113.828 417.743 113.66 417.399 113.492C417.055 113.324 416.759 113.076 416.511 112.748C416.263 112.42 416.139 111.992 416.139 111.464C416.139 110.68 416.423 110.068 416.991 109.628C417.559 109.18 418.299 108.956 419.211 108.956C420.139 108.956 420.887 109.18 421.455 109.628C422.023 110.068 422.327 110.684 422.367 111.476H420.147C420.131 111.204 420.031 110.992 419.847 110.84C419.663 110.68 419.427 110.6 419.139 110.6C418.891 110.6 418.691 110.668 418.539 110.804C418.387 110.932 418.311 111.12 418.311 111.368C418.311 111.64 418.439 111.852 418.695 112.004C418.951 112.156 419.351 112.32 419.895 112.496C420.439 112.68 420.879 112.856 421.215 113.024C421.559 113.192 421.855 113.436 422.103 113.756C422.351 114.076 422.475 114.488 422.475 114.992C422.475 115.472 422.351 115.908 422.103 116.3C421.863 116.692 421.511 117.004 421.047 117.236C420.583 117.468 420.035 117.584 419.403 117.584ZM426.786 117.584C426.17 117.584 425.618 117.484 425.13 117.284C424.642 117.084 424.25 116.788 423.954 116.396C423.666 116.004 423.514 115.532 423.498 114.98H425.682C425.714 115.292 425.822 115.532 426.006 115.7C426.19 115.86 426.43 115.94 426.726 115.94C427.03 115.94 427.27 115.872 427.446 115.736C427.622 115.592 427.71 115.396 427.71 115.148C427.71 114.94 427.638 114.768 427.494 114.632C427.358 114.496 427.186 114.384 426.978 114.296C426.778 114.208 426.49 114.108 426.114 113.996C425.57 113.828 425.126 113.66 424.782 113.492C424.438 113.324 424.142 113.076 423.894 112.748C423.646 112.42 423.522 111.992 423.522 111.464C423.522 110.68 423.806 110.068 424.374 109.628C424.942 109.18 425.682 108.956 426.594 108.956C427.522 108.956 428.27 109.18 428.838 109.628C429.406 110.068 429.71 110.684 429.75 111.476H427.53C427.514 111.204 427.414 110.992 427.23 110.84C427.046 110.68 426.81 110.6 426.522 110.6C426.274 110.6 426.074 110.668 425.922 110.804C425.77 110.932 425.694 111.12 425.694 111.368C425.694 111.64 425.822 111.852 426.078 112.004C426.334 112.156 426.734 112.32 427.278 112.496C427.822 112.68 428.262 112.856 428.598 113.024C428.942 113.192 429.238 113.436 429.486 113.756C429.734 114.076 429.858 114.488 429.858 114.992C429.858 115.472 429.734 115.908 429.486 116.3C429.246 116.692 428.894 117.004 428.43 117.236C427.966 117.468 427.418 117.584 426.786 117.584ZM440.661 109.076V117.5H438.609V112.448L436.725 117.5H435.069L433.173 112.436V117.5H431.121V109.076H433.545L435.909 114.908L438.249 109.076H440.661ZM447.381 116.012H444.237L443.733 117.5H441.585L444.633 109.076H447.009L450.057 117.5H447.885L447.381 116.012ZM446.853 114.428L445.809 111.344L444.777 114.428H446.853ZM458.52 117.5H456.468L453.036 112.304V117.5H450.984V109.076H453.036L456.468 114.296V109.076H458.52V117.5ZM210.438 133.604L209.106 137.048H207.798L208.494 133.604H210.438ZM221.216 127.076V135.5H219.164V130.448L217.28 135.5H215.624L213.728 130.436V135.5H211.676V127.076H214.1L216.464 132.908L218.804 127.076H221.216ZM224.707 127.076V132.116C224.707 132.62 224.831 133.008 225.079 133.28C225.327 133.552 225.691 133.688 226.171 133.688C226.651 133.688 227.019 133.552 227.275 133.28C227.531 133.008 227.659 132.62 227.659 132.116V127.076H229.711V132.104C229.711 132.856 229.551 133.492 229.231 134.012C228.911 134.532 228.479 134.924 227.935 135.188C227.399 135.452 226.799 135.584 226.135 135.584C225.471 135.584 224.875 135.456 224.347 135.2C223.827 134.936 223.415 134.544 223.111 134.024C222.807 133.496 222.655 132.856 222.655 132.104V127.076H224.707ZM234.2 135.584C233.584 135.584 233.032 135.484 232.544 135.284C232.056 135.084 231.664 134.788 231.368 134.396C231.08 134.004 230.928 133.532 230.912 132.98H233.096C233.128 133.292 233.236 133.532 233.42 133.7C233.604 133.86 233.844 133.94 234.14 133.94C234.444 133.94 234.684 133.872 234.86 133.736C235.036 133.592 235.124 133.396 235.124 133.148C235.124 132.94 235.052 132.768 234.908 132.632C234.772 132.496 234.6 132.384 234.392 132.296C234.192 132.208 233.904 132.108 233.528 131.996C232.984 131.828 232.54 131.66 232.196 131.492C231.852 131.324 231.556 131.076 231.308 130.748C231.06 130.42 230.936 129.992 230.936 129.464C230.936 128.68 231.22 128.068 231.788 127.628C232.356 127.18 233.096 126.956 234.008 126.956C234.936 126.956 235.684 127.18 236.252 127.628C236.82 128.068 237.124 128.684 237.164 129.476H234.944C234.928 129.204 234.828 128.992 234.644 128.84C234.46 128.68 234.224 128.6 233.936 128.6C233.688 128.6 233.488 128.668 233.336 128.804C233.184 128.932 233.108 129.12 233.108 129.368C233.108 129.64 233.236 129.852 233.492 130.004C233.748 130.156 234.148 130.32 234.692 130.496C235.236 130.68 235.676 130.856 236.012 131.024C236.356 131.192 236.652 131.436 236.9 131.756C237.148 132.076 237.272 132.488 237.272 132.992C237.272 133.472 237.148 133.908 236.9 134.3C236.66 134.692 236.308 135.004 235.844 135.236C235.38 135.468 234.832 135.584 234.2 135.584ZM240.587 127.076V135.5H238.535V127.076H240.587ZM241.726 131.276C241.726 130.444 241.906 129.704 242.266 129.056C242.626 128.4 243.126 127.892 243.766 127.532C244.414 127.164 245.146 126.98 245.962 126.98C246.962 126.98 247.818 127.244 248.53 127.772C249.242 128.3 249.718 129.02 249.958 129.932H247.702C247.534 129.58 247.294 129.312 246.982 129.128C246.678 128.944 246.33 128.852 245.938 128.852C245.306 128.852 244.794 129.072 244.402 129.512C244.01 129.952 243.814 130.54 243.814 131.276C243.814 132.012 244.01 132.6 244.402 133.04C244.794 133.48 245.306 133.7 245.938 133.7C246.33 133.7 246.678 133.608 246.982 133.424C247.294 133.24 247.534 132.972 247.702 132.62H249.958C249.718 133.532 249.242 134.252 248.53 134.78C247.818 135.3 246.962 135.56 245.962 135.56C245.146 135.56 244.414 135.38 243.766 135.02C243.126 134.652 242.626 134.144 242.266 133.496C241.906 132.848 241.726 132.108 241.726 131.276ZM259.818 127.076V128.72H257.586V135.5H255.534V128.72H253.302V127.076H259.818ZM262.9 128.72V130.424H265.648V132.008H262.9V133.856H266.008V135.5H260.848V127.076H266.008V128.72H262.9ZM272.584 134.012H269.44L268.936 135.5H266.788L269.836 127.076H272.212L275.26 135.5H273.088L272.584 134.012ZM272.056 132.428L271.012 129.344L269.98 132.428H272.056ZM275.839 131.276C275.839 130.444 276.019 129.704 276.379 129.056C276.739 128.4 277.239 127.892 277.879 127.532C278.527 127.164 279.259 126.98 280.075 126.98C281.075 126.98 281.931 127.244 282.643 127.772C283.355 128.3 283.831 129.02 284.071 129.932H281.815C281.647 129.58 281.407 129.312 281.095 129.128C280.791 128.944 280.443 128.852 280.051 128.852C279.419 128.852 278.907 129.072 278.515 129.512C278.123 129.952 277.927 130.54 277.927 131.276C277.927 132.012 278.123 132.6 278.515 133.04C278.907 133.48 279.419 133.7 280.051 133.7C280.443 133.7 280.791 133.608 281.095 133.424C281.407 133.24 281.647 132.972 281.815 132.62H284.071C283.831 133.532 283.355 134.252 282.643 134.78C281.931 135.3 281.075 135.56 280.075 135.56C279.259 135.56 278.527 135.38 277.879 135.02C277.239 134.652 276.739 134.144 276.379 133.496C276.019 132.848 275.839 132.108 275.839 131.276ZM292.624 127.076V135.5H290.572V132.032H287.38V135.5H285.328V127.076H287.38V130.376H290.572V127.076H292.624ZM296.157 128.72V130.424H298.905V132.008H296.157V133.856H299.265V135.5H294.105V127.076H299.265V128.72H296.157ZM304.894 135.5L303.142 132.32H302.65V135.5H300.598V127.076H304.042C304.706 127.076 305.27 127.192 305.734 127.424C306.206 127.656 306.558 127.976 306.79 128.384C307.022 128.784 307.138 129.232 307.138 129.728C307.138 130.288 306.978 130.788 306.658 131.228C306.346 131.668 305.882 131.98 305.266 132.164L307.21 135.5H304.894ZM302.65 130.868H303.922C304.298 130.868 304.578 130.776 304.762 130.592C304.954 130.408 305.05 130.148 305.05 129.812C305.05 129.492 304.954 129.24 304.762 129.056C304.578 128.872 304.298 128.78 303.922 128.78H302.65V130.868ZM316.213 134.012H313.069L312.565 135.5H310.417L313.465 127.076H315.841L318.889 135.5H316.717L316.213 134.012ZM315.685 132.428L314.641 129.344L313.609 132.428H315.685ZM327.352 135.5H325.3L321.868 130.304V135.5H319.816V127.076H321.868L325.3 132.296V127.076H327.352V135.5ZM331.996 127.076C332.884 127.076 333.66 127.252 334.324 127.604C334.988 127.956 335.5 128.452 335.86 129.092C336.228 129.724 336.412 130.456 336.412 131.288C336.412 132.112 336.228 132.844 335.86 133.484C335.5 134.124 334.984 134.62 334.312 134.972C333.648 135.324 332.876 135.5 331.996 135.5H328.84V127.076H331.996ZM331.864 133.724C332.64 133.724 333.244 133.512 333.676 133.088C334.108 132.664 334.324 132.064 334.324 131.288C334.324 130.512 334.108 129.908 333.676 129.476C333.244 129.044 332.64 128.828 331.864 128.828H330.892V133.724H331.864ZM345.585 127.076V128.72H342.153V130.496H344.721V132.092H342.153V135.5H340.101V127.076H345.585ZM348.716 127.076V135.5H346.664V127.076H348.716ZM352.255 133.916H354.943V135.5H350.203V127.076H352.255V133.916ZM365.462 127.076V135.5H363.41V130.448L361.526 135.5H359.87L357.974 130.436V135.5H355.922V127.076H358.346L360.71 132.908L363.05 127.076H365.462ZM375.9 129.788C375.9 130.276 375.788 130.724 375.564 131.132C375.34 131.532 374.996 131.856 374.532 132.104C374.068 132.352 373.492 132.476 372.804 132.476H371.532V135.5H369.48V127.076H372.804C373.476 127.076 374.044 127.192 374.508 127.424C374.972 127.656 375.32 127.976 375.552 128.384C375.784 128.792 375.9 129.26 375.9 129.788ZM372.648 130.844C373.04 130.844 373.332 130.752 373.524 130.568C373.716 130.384 373.812 130.124 373.812 129.788C373.812 129.452 373.716 129.192 373.524 129.008C373.332 128.824 373.04 128.732 372.648 128.732H371.532V130.844H372.648ZM381.265 135.5L379.513 132.32H379.021V135.5H376.969V127.076H380.413C381.077 127.076 381.641 127.192 382.105 127.424C382.577 127.656 382.929 127.976 383.161 128.384C383.393 128.784 383.509 129.232 383.509 129.728C383.509 130.288 383.349 130.788 383.029 131.228C382.717 131.668 382.253 131.98 381.637 132.164L383.581 135.5H381.265ZM379.021 130.868H380.293C380.669 130.868 380.949 130.776 381.133 130.592C381.325 130.408 381.421 130.148 381.421 129.812C381.421 129.492 381.325 129.24 381.133 129.056C380.949 128.872 380.669 128.78 380.293 128.78H379.021V130.868ZM388.781 135.584C387.989 135.584 387.261 135.4 386.597 135.032C385.941 134.664 385.417 134.152 385.025 133.496C384.641 132.832 384.449 132.088 384.449 131.264C384.449 130.44 384.641 129.7 385.025 129.044C385.417 128.388 385.941 127.876 386.597 127.508C387.261 127.14 387.989 126.956 388.781 126.956C389.573 126.956 390.297 127.14 390.953 127.508C391.617 127.876 392.137 128.388 392.513 129.044C392.897 129.7 393.089 130.44 393.089 131.264C393.089 132.088 392.897 132.832 392.513 133.496C392.129 134.152 391.609 134.664 390.953 135.032C390.297 135.4 389.573 135.584 388.781 135.584ZM388.781 133.712C389.453 133.712 389.989 133.488 390.389 133.04C390.797 132.592 391.001 132 391.001 131.264C391.001 130.52 390.797 129.928 390.389 129.488C389.989 129.04 389.453 128.816 388.781 128.816C388.101 128.816 387.557 129.036 387.149 129.476C386.749 129.916 386.549 130.512 386.549 131.264C386.549 132.008 386.749 132.604 387.149 133.052C387.557 133.492 388.101 133.712 388.781 133.712ZM397.386 127.076C398.274 127.076 399.05 127.252 399.714 127.604C400.378 127.956 400.89 128.452 401.25 129.092C401.618 129.724 401.802 130.456 401.802 131.288C401.802 132.112 401.618 132.844 401.25 133.484C400.89 134.124 400.374 134.62 399.702 134.972C399.038 135.324 398.266 135.5 397.386 135.5H394.23V127.076H397.386ZM397.254 133.724C398.03 133.724 398.634 133.512 399.066 133.088C399.498 132.664 399.714 132.064 399.714 131.288C399.714 130.512 399.498 129.908 399.066 129.476C398.634 129.044 398.03 128.828 397.254 128.828H396.282V133.724H397.254ZM404.965 127.076V132.116C404.965 132.62 405.089 133.008 405.337 133.28C405.585 133.552 405.949 133.688 406.429 133.688C406.909 133.688 407.277 133.552 407.533 133.28C407.789 133.008 407.917 132.62 407.917 132.116V127.076H409.969V132.104C409.969 132.856 409.809 133.492 409.489 134.012C409.169 134.532 408.737 134.924 408.193 135.188C407.657 135.452 407.057 135.584 406.393 135.584C405.729 135.584 405.133 135.456 404.605 135.2C404.085 134.936 403.673 134.544 403.369 134.024C403.065 133.496 402.913 132.856 402.913 132.104V127.076H404.965ZM411.062 131.276C411.062 130.444 411.242 129.704 411.602 129.056C411.962 128.4 412.462 127.892 413.102 127.532C413.75 127.164 414.482 126.98 415.298 126.98C416.298 126.98 417.154 127.244 417.866 127.772C418.578 128.3 419.054 129.02 419.294 129.932H417.038C416.87 129.58 416.63 129.312 416.318 129.128C416.014 128.944 415.666 128.852 415.274 128.852C414.642 128.852 414.13 129.072 413.738 129.512C413.346 129.952 413.15 130.54 413.15 131.276C413.15 132.012 413.346 132.6 413.738 133.04C414.13 133.48 414.642 133.7 415.274 133.7C415.666 133.7 416.014 133.608 416.318 133.424C416.63 133.24 416.87 132.972 417.038 132.62H419.294C419.054 133.532 418.578 134.252 417.866 134.78C417.154 135.3 416.298 135.56 415.298 135.56C414.482 135.56 413.75 135.38 413.102 135.02C412.462 134.652 411.962 134.144 411.602 133.496C411.242 132.848 411.062 132.108 411.062 131.276ZM422.603 128.72V130.424H425.351V132.008H422.603V133.856H425.711V135.5H420.551V127.076H425.711V128.72H422.603ZM431.339 135.5L429.587 132.32H429.095V135.5H427.043V127.076H430.487C431.151 127.076 431.715 127.192 432.179 127.424C432.651 127.656 433.003 127.976 433.235 128.384C433.467 128.784 433.583 129.232 433.583 129.728C433.583 130.288 433.423 130.788 433.103 131.228C432.791 131.668 432.327 131.98 431.711 132.164L433.655 135.5H431.339ZM429.095 130.868H430.367C430.743 130.868 431.023 130.776 431.207 130.592C431.399 130.408 431.495 130.148 431.495 129.812C431.495 129.492 431.399 129.24 431.207 129.056C431.023 128.872 430.743 128.78 430.367 128.78H429.095V130.868ZM435.831 135.596C435.471 135.596 435.175 135.492 434.943 135.284C434.719 135.068 434.607 134.804 434.607 134.492C434.607 134.172 434.719 133.904 434.943 133.688C435.175 133.472 435.471 133.364 435.831 133.364C436.183 133.364 436.471 133.472 436.695 133.688C436.927 133.904 437.043 134.172 437.043 134.492C437.043 134.804 436.927 135.068 436.695 135.284C436.471 135.492 436.183 135.596 435.831 135.596Z",
    fill: "white"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M428.23 30.4321C430.843 30.4321 432.916 31.2236 434.449 32.8065C436.006 34.3894 436.785 36.5879 436.785 39.4019V51.6883H430.378V40.2688C430.378 38.912 430.014 37.8693 429.285 37.1406C428.582 36.3869 427.602 36.01 426.346 36.01C425.089 36.01 424.097 36.3869 423.368 37.1406C422.665 37.8693 422.313 38.912 422.313 40.2688V51.6883H415.906V40.2688C415.906 38.912 415.542 37.8693 414.813 37.1406C414.109 36.3869 413.13 36.01 411.873 36.01C410.617 36.01 409.625 36.3869 408.896 37.1406C408.192 37.8693 407.841 38.912 407.841 40.2688V51.6883H401.396V30.6583H407.841V33.2964C408.494 32.417 409.348 31.7261 410.403 31.2236C411.459 30.6959 412.652 30.4321 413.984 30.4321C415.567 30.4321 416.974 30.7713 418.205 31.4497C419.461 32.1281 420.441 33.0954 421.145 34.3517C421.873 33.1959 422.866 32.2537 424.122 31.5251C425.378 30.7964 426.748 30.4321 428.23 30.4321Z",
    fill: "#FF9327"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M393.522 28.4723C392.391 28.4723 391.462 28.1457 390.733 27.4924C390.029 26.814 389.678 25.9849 389.678 25.005C389.678 24 390.029 23.1708 390.733 22.5176C391.462 21.8392 392.391 21.5 393.522 21.5C394.627 21.5 395.532 21.8392 396.235 22.5176C396.964 23.1708 397.328 24 397.328 25.005C397.328 25.9849 396.964 26.814 396.235 27.4924C395.532 28.1457 394.627 28.4723 393.522 28.4723ZM396.725 30.6582V51.6883H390.281V30.6582H396.725Z",
    fill: "#FF9327"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M385.61 23.7988V51.6881H379.166V23.7988H385.61Z",
    fill: "#FF9327"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M352.305 41.1358C352.305 38.975 352.707 37.078 353.511 35.4449C354.34 33.8117 355.458 32.5554 356.865 31.676C358.272 30.7966 359.842 30.3569 361.576 30.3569C363.058 30.3569 364.352 30.6584 365.458 31.2615C366.589 31.8645 367.455 32.6559 368.058 33.6358V30.6584H374.503V51.6885H368.058V48.7111C367.43 49.691 366.551 50.4825 365.42 51.0855C364.315 51.6885 363.021 51.99 361.538 51.99C359.83 51.99 358.272 51.5503 356.865 50.6709C355.458 49.7664 354.34 48.4976 353.511 46.8644C352.707 45.2061 352.305 43.2966 352.305 41.1358ZM368.058 41.1735C368.058 39.5654 367.606 38.2966 366.702 37.367C365.822 36.4373 364.742 35.9725 363.46 35.9725C362.179 35.9725 361.086 36.4373 360.182 37.367C359.302 38.2715 358.862 39.5277 358.862 41.1358C358.862 42.7438 359.302 44.0252 360.182 44.98C361.086 45.9096 362.179 46.3744 363.46 46.3744C364.742 46.3744 365.822 45.9096 366.702 44.98C367.606 44.0503 368.058 42.7815 368.058 41.1735Z",
    fill: "#FF9327"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M348.934 25.231V51.6881H342.489V40.7962H332.464V51.6881H326.02V25.231H332.464V35.5952H342.489V25.231H348.934Z",
    fill: "#FF9327"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M321.349 23.7988V51.6881H314.904V23.7988H321.349Z",
    fill: "#FF9327"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M311.504 40.8343C311.504 41.4373 311.467 42.0654 311.391 42.7187H296.806C296.906 44.0252 297.321 45.0302 298.05 45.7337C298.803 46.4121 299.72 46.7513 300.801 46.7513C302.409 46.7513 303.527 46.0729 304.155 44.7162H311.014C310.663 46.0981 310.022 47.3418 309.092 48.4473C308.188 49.5528 307.045 50.4197 305.663 51.0478C304.281 51.6759 302.736 51.99 301.027 51.99C298.967 51.99 297.133 51.5503 295.525 50.6709C293.916 49.7915 292.66 48.5352 291.756 46.9021C290.851 45.2689 290.399 43.3594 290.399 41.1735C290.399 38.9875 290.839 37.078 291.718 35.4449C292.623 33.8117 293.879 32.5554 295.487 31.676C297.095 30.7966 298.942 30.3569 301.027 30.3569C303.062 30.3569 304.871 30.7841 306.454 31.6383C308.037 32.4926 309.268 33.7112 310.148 35.2941C311.052 36.877 311.504 38.7237 311.504 40.8343ZM304.909 39.1383C304.909 38.0328 304.532 37.1534 303.778 36.5001C303.024 35.8469 302.082 35.5202 300.952 35.5202C299.871 35.5202 298.954 35.8343 298.2 36.4624C297.472 37.0906 297.019 37.9825 296.844 39.1383H304.909Z",
    fill: "#FF9327"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M264.819 41.1354C264.819 38.9746 265.221 37.0777 266.025 35.4445C266.854 33.8113 267.973 32.5551 269.38 31.6757C270.787 30.7963 272.357 30.3566 274.091 30.3566C275.473 30.3566 276.729 30.6455 277.859 31.2234C279.015 31.8013 279.92 32.5802 280.573 33.5601V23.7988H287.018V51.6881H280.573V48.6731C279.97 49.6781 279.103 50.4821 277.973 51.0851C276.867 51.6881 275.573 51.9896 274.091 51.9896C272.357 51.9896 270.787 51.55 269.38 50.6706C267.973 49.766 266.854 48.4972 266.025 46.864C265.221 45.2058 264.819 43.2962 264.819 41.1354ZM280.573 41.1731C280.573 39.5651 280.121 38.2962 279.216 37.3666C278.337 36.437 277.256 35.9721 275.975 35.9721C274.694 35.9721 273.601 36.437 272.696 37.3666C271.817 38.2711 271.377 39.5274 271.377 41.1354C271.377 42.7435 271.817 44.0249 272.696 44.9796C273.601 45.9093 274.694 46.3741 275.975 46.3741C277.256 46.3741 278.337 45.9093 279.216 44.9796C280.121 44.05 280.573 42.7811 280.573 41.1731Z",
    fill: "#FF9327"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M246.966 33.6355C247.569 32.6556 248.436 31.8641 249.566 31.2611C250.697 30.6581 251.991 30.3566 253.448 30.3566C255.182 30.3566 256.752 30.7963 258.159 31.6757C259.566 32.5551 260.672 33.8113 261.476 35.4445C262.305 37.0777 262.719 38.9746 262.719 41.1354C262.719 43.2962 262.305 45.2058 261.476 46.864C260.672 48.4972 259.566 49.766 258.159 50.6706C256.752 51.55 255.182 51.9896 253.448 51.9896C251.966 51.9896 250.672 51.7007 249.566 51.1228C248.461 50.5198 247.594 49.7284 246.966 48.7485V51.6881H240.521V23.7988H246.966V33.6355ZM256.162 41.1354C256.162 39.5274 255.709 38.2711 254.805 37.3666C253.925 36.437 252.832 35.9721 251.526 35.9721C250.245 35.9721 249.152 36.437 248.247 37.3666C247.368 38.2962 246.928 39.5651 246.928 41.1731C246.928 42.7811 247.368 44.05 248.247 44.9796C249.152 45.9093 250.245 46.3741 251.526 46.3741C252.807 46.3741 253.9 45.9093 254.805 44.9796C255.709 44.0249 256.162 42.7435 256.162 41.1354Z",
    fill: "#FF9327"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M229.203 47.0148H219.329L217.746 51.6881H211L220.573 25.231H228.035L237.608 51.6881H230.786L229.203 47.0148ZM227.545 42.0399L224.266 32.354L221.025 42.0399H227.545Z",
    fill: "#FF9327"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.982 83.0062H371.958V88.8186H354.109V83.2124L363.673 71.6288H354.191V65.8164H371.752V71.4227L361.982 83.0062Z",
    fill: "#FF9327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.668 76.9467C351.668 77.6063 351.627 78.2933 351.545 79.0078H335.591C335.701 80.4369 336.155 81.5362 336.952 82.3057C337.776 83.0477 338.779 83.4187 339.961 83.4187C341.72 83.4187 342.943 82.6767 343.63 81.1926H351.132C350.748 82.7041 350.047 84.0645 349.03 85.2737C348.041 86.4829 346.79 87.431 345.279 88.118C343.767 88.8051 342.077 89.1486 340.208 89.1486C337.955 89.1486 335.949 88.6677 334.19 87.7058C332.431 86.744 331.057 85.3699 330.068 83.5836C329.078 81.7972 328.583 79.7086 328.583 77.3177C328.583 74.9268 329.064 72.8382 330.026 71.0519C331.016 69.2656 332.39 67.8915 334.149 66.9296C335.907 65.9677 337.927 65.4868 340.208 65.4868C342.434 65.4868 344.413 65.954 346.144 66.8884C347.876 67.8228 349.222 69.1556 350.184 70.887C351.174 72.6183 351.668 74.6382 351.668 76.9467ZM344.454 75.0917C344.454 73.8825 344.042 72.9206 343.218 72.2061C342.393 71.4916 341.363 71.1343 340.126 71.1343C338.944 71.1343 337.941 71.4778 337.117 72.1649C336.32 72.8519 335.825 73.8275 335.633 75.0917H344.454Z",
    fill: "#FF9327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.673 71.6699H322.88V88.8186H315.831V71.6699H313.275V65.8163H315.831V65.1568C315.831 62.3261 316.642 60.1826 318.263 58.726C319.885 57.242 322.262 56.5 325.395 56.5C325.917 56.5 326.302 56.5137 326.549 56.5412V62.5185C325.202 62.4361 324.254 62.6284 323.705 63.0956C323.155 63.5628 322.88 64.401 322.88 65.6102V65.8163H326.673V71.6699Z",
    fill: "#FF9327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.75 77.2765C285.75 74.9131 286.19 72.8382 287.07 71.0519C287.977 69.2656 289.199 67.8915 290.738 66.9296C292.277 65.9677 293.995 65.4868 295.891 65.4868C297.513 65.4868 298.928 65.8166 300.137 66.4762C301.374 67.1357 302.322 68.0014 302.982 69.0732V65.8166H310.031V88.8188H302.982V85.5622C302.295 86.634 301.333 87.4997 300.096 88.1593C298.887 88.8188 297.471 89.1486 295.85 89.1486C293.981 89.1486 292.277 88.6677 290.738 87.7058C289.199 86.7165 287.977 85.3286 287.07 83.5423C286.19 81.7285 285.75 79.6399 285.75 77.2765ZM302.982 77.3177C302.982 75.5589 302.487 74.1711 301.498 73.1542C300.536 72.1374 299.354 71.629 297.952 71.629C296.551 71.629 295.355 72.1374 294.366 73.1542C293.404 74.1436 292.923 75.5177 292.923 77.2765C292.923 79.0353 293.404 80.4369 294.366 81.4812C295.355 82.498 296.551 83.0064 297.952 83.0064C299.354 83.0064 300.536 82.498 301.498 81.4812C302.487 80.4644 302.982 79.0765 302.982 77.3177Z",
    fill: "#FF9327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.063 59.8804V88.8187H275.014V76.9053H264.049V88.8187H257V59.8804H264.049V71.2166H275.014V59.8804H282.063Z",
    fill: "#FF9327"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_805",
    x: 243.5,
    y: 50,
    width: 149.958,
    height: 67.6484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_805"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_805",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalart);
export default __webpack_public_path__ + "static/media/digitalart.bceabda5fb308d7169eb7af4992a18cb.svg";
export { ForwardRef as ReactComponent };